import React, { Component } from 'react';
import { getUserType } from "../../services/auth";
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { archiveKey, readArchive, writeArchive, snapshotList } from '../../services/history-archive';
//import SelectPure from "select-pure";

import Header from '../../components/header';
import TitlePage from '../../components/title-page';
// import Search from '../../components/search';
import EmailPreview from '../../components/email-preview';
import Search from '../../components/search';



import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

// import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
// import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
// import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
// import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';

//images
import logoPartner from '../../assets/img/partner/fort-giants/logo-partner.png';

export default class project extends Component {
	state = {
		search: "",
		//getPublisherNames: [],
		//selectedPublishersSort: 'A-Z',
		order: "First",
		user_type: "",
		company_id: 0,
		project_id: 0,
		company_name: "",
		company_description: "",
		logo_src: "",
		project_title: "",
		banner_title: "",
		banner_description: "",
		banner_src: "",
		links: [],
		publishers: [],
		// Faltaba en el estado inicial: hasta que loadCategories responde (o si
		// falla) quedaba en undefined y todo lo que la recorre tenia que acordarse
		// de protegerse.
		categories: [],
		list_selections: [],
		new_list: false,
		checkedItens: [],
		contacts: [],
		messages: [],
		available_links: [],
		selected_list: 0,
		modal_publishers: "closed",
		modal_message: "closed",
		modal_unlock_files: "closed",
		modal_delete: "closed",
		modal_send: "closed",
		modal_status: "closed",
		modal_submitted: "closed",
		modal_preview: 'closed',
		preview_subject: "",
		preview_cc: "",
		preview_message: "",
		default_message: "",
		sent_at: "",
		subject: "",
		cc: [],
		message: "",
		chat_modal: "closed",
		chat_message: "",
		render_update: false,
		submissionLists: [],
		submissionListsCC: [],
		selectedSubmissionList: null,
		selectedContacts: {},
		loading_lists: true,
		lists_error: "",
		dispatch_progress: null,
		type_list: "publishers",
		send_to: 'all',
		modal_details_id : -1,
		schedule_inputs: {},
		schedule_target: null,
		schedule_error: "",
		modal_schedule: "closed",
		modal_last_sent: "closed",
		last_sent_target: null,
		history_open: false,
		history_loading: false,
		history_error: ""
	}

	// Fuera del state: solo marca si los archivos del historial ya se pidieron,
	// no se pinta en ningun sitio y no tiene por que disparar un render.
	history_files_ready = false

	getPublisherNames = (submissionList) => {
	const { publishers = [] } = this.state;

	// Filtramos todos los contactos de tipo "publisher"
	const contactPublishers = submissionList.contacts?.filter(
		(c) => c.contact_type === "publisher"
	) || [];

	// Buscamos el nombre de cada publisher según su contact_id
	const names = contactPublishers.map((contactPublisher) => {
		const publisher = publishers.find(p => p.id === contactPublisher.contact_id);
		return publisher ? (publisher.contact_name || publisher.name || '') : '';
	});

	// Quitamos vacíos y retornamos un arreglo con todos los nombres
	return names.filter(Boolean);
};




	async componentDidMount() {
  document.querySelector('body').classList.remove("no-scroll");

  const company_id = this.props.match.params.company_id;
  const project_id = this.props.match.params.project_id;

  this.setState({ company_id, project_id });

  const currentUser = getUserType();
  if (currentUser === "admin") {
    this.setState({ user_type: "admin" });
    await this.loadPublishers(company_id, project_id);
    await this.loadCategories(company_id, project_id);
  } else {
    this.setState({
      user_type: "normal",
      type_list: "categories"
    });
    await this.loadCategories(company_id, project_id);
  }

  await this.loadApiProject(company_id, project_id);
  await this.loadLists();
  
}


	loadApiProject = async (company_id, project_id) => {
		try {
			const response = await api.get(`companies/${company_id}/projects/${project_id}`);
			const response2 = await api.get(`companies/${company_id}/projects/${project_id}/banner`);
			const response3 = await api.get(`companies/${company_id}/projects/${project_id}/files`);
			//const response4 = await api.get(`project_submission_list/${project_id}`)

			await this.setState({
				project_type: response.data.project_type,
				project_title: response.data.title, 
				company_name: response.data.company_name,
				//sent_at: response.data.sent_at,
				company_description: response.data.company_description,
				banner_title: response2.data.title,
				banner_description: response2.data.description,
				links: response3.data,
			});

			if(response.data.logo_url) {
				this.setState({
					logo_src: 'https://seat7-uploads.s3.amazonaws.com/'+response.data.logo_url,
				})
			}

			if(response2.data.image_url) {
				this.setState({
					banner_src: 'https://seat7-uploads.s3.amazonaws.com/'+response2.data.image_url,
				})
			}
		} catch (error) {
			console.log(error);
		}
	}

    	// ----------------------------------------------------
	// LOAD PUBLISHER LIST --------------------------------
	// ----------------------------------------------------
	loadPublishers = async (company_id, project_id) => {
		try {
			const response = await api.get(`publishers`);
			const publishers = response.data || []
			await this.loadCollaborators(publishers);

			return this.setState({
				publishers,
				checkedItens: []
			});
		} catch (error) {
			console.log(error);
		}
	}
    
	
	// En lotes en vez de una peticion simultanea por publisher (son mas de 250):
	// menos presion sobre la API y menos timeouts, que es lo que disparaba el
	// fallo de carga. loadPublisherCollaborators ya nunca rechaza.
	COLLABORATORS_BATCH_SIZE = 12

	loadCollaborators = async (publishers) => {
		for (let i = 0; i < publishers.length; i += this.COLLABORATORS_BATCH_SIZE) {
			const batch = publishers.slice(i, i + this.COLLABORATORS_BATCH_SIZE);
			await Promise.all(batch.map(this.loadPublisherCollaborators));
		}
	}
	
	loadCollaboratorsCC = async (publishers) => {
		try {
			const collaboratorsPromises = publishers.map(this.loadPublisherCollaboratorsCC)
			return Promise.all(collaboratorsPromises);
		} catch (error) {
			console.log(error);
		}
	}

	loadPublisherCollaborators = async (publisher) => {
		try {
			const collaboratorsRequest = await api.get(`publishers/${publisher.id}/employees`)
			publisher.collaborators = collaboratorsRequest.data || []
		} catch (error) {
			// Un fallo aislado no puede tumbar la lista entera: antes el rechazo subia
			// al Promise.all, saltaba al catch de loadPublishers y el setState con los
			// publishers no llegaba a ejecutarse, dejando el modal vacio y sin aviso.
			console.log(error);
			publisher.collaborators = []
		}

		return publisher.collaborators
	}


	
	


	componentWillUnmount() {
		if (this.queueTimer) {
			clearInterval(this.queueTimer);
			this.queueTimer = null;
		}
	}

	// ----------------------------------------------------
	// SELECCION DERIVADA ---------------------------------
	// ----------------------------------------------------

	// Todo lo de "publishers seleccionados" sale de selectedContacts, que es lo
	// unico que saveListContacts manda a la API.
	//
	// Antes vivia en un array aparte (selectedPublishers) guardado en
	// localStorage por proyecto, y modalPublishers no lo reiniciaba al abrir un
	// grupo. Resultado: la pestana listaba publishers de otro grupo o de otra
	// sesion, que Save no iba a guardar, y el boton Remove no los quitaba.
	//
	// Un publisher cuenta como seleccionado si lo esta su cuenta de compania o
	// cualquiera de sus personas: eso es exactamente lo que recibira el correo.
	publisherSelectedPeople = (publisher) => {
		const {selectedContacts} = this.state;
		const people = [];

		if (selectedContacts[`publisher-${publisher.id}`]) {
			people.push({
				key: `publisher-${publisher.id}`,
				name: publisher.contact_name || publisher.name || "",
				email: publisher.email || ""
			});
		}

		(publisher.collaborators || []).forEach(collaborator => {
			if (selectedContacts[`publisher_employee-${collaborator.id}`]) {
				people.push({
					key: `publisher_employee-${collaborator.id}`,
					name: collaborator.name || "",
					email: collaborator.email || ""
				});
			}
		});

		return people;
	}

	publisherHasSelection = (publisher) => this.publisherSelectedPeople(publisher).length > 0

	selectedPublishersList = () => (this.state.publishers || []).filter(this.publisherHasSelection)

	// Las claves de contacto con las que este publisher aparece dentro de un
	// grupo: su cuenta de compania y la de cada una de sus personas.
	publisherContactKeys = (publisher) => {
		const keys = new Set([`publisher-${publisher.id}`]);

		(publisher.collaborators || []).forEach(collaborator => {
			keys.add(`publisher_employee-${collaborator.id}`);
		});

		return keys;
	}

	// Cuando le llego este proyecto a este publisher por ultima vez, mirando
	// todos los grupos, el abierto incluido: antes de volver a escribirle lo que
	// importa es si ya le llego y hace cuanto, no por cual de los grupos fue.
	//
	// Se prefiere el sent_at del contacto sobre el del grupo, igual que en el
	// historial: es por destinatario y por tanto mas fiel.
	publisherLastSentAt = (publisher) => {
		const keys = this.publisherContactKeys(publisher);
		let latest = null;

		(this.state.submissionLists || []).forEach(list => {
			(list.contacts || []).forEach(contact => {
				if (!keys.has(`${contact.contact_type}-${contact.contact_id}`)) {
					return;
				}

				latest = this.keepLatestDate(latest, contact.sent_at || list.sent_at);
			});
		});

		return latest;
	}

	// Dias de calendario, no horas transcurridas: un envio de anoche a las 23:00
	// visto esta mañana es "ayer", aunque solo hayan pasado nueve horas.
	startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate())

	// "hace 3 dias" se lee de un vistazo; "2026-03-12" hay que calcularlo. A
	// partir de un mes la cuenta exacta deja de decir nada util, asi que pasa a
	// meses y luego a años.
	relativeSentLabel = (value) => {
		// El !value va aparte: new Date(null) no es invalida, es el epoch, y sin
		// esta linea un valor nulo salia como "56 years ago".
		if (!value) {
			return "";
		}

		const time = new Date(value).getTime();

		if (isNaN(time)) {
			return "";
		}

		const days = Math.round(
			(this.startOfDay(new Date()).getTime() - this.startOfDay(new Date(time)).getTime()) / 86400000
		);

		// days <= 0 cubre tambien una fecha futura por reloj desajustado.
		if (days <= 0) {
			return "today";
		}

		if (days === 1) {
			return "yesterday";
		}

		if (days < 7) {
			return `${days} days ago`;
		}

		const weeks = Math.floor(days / 7);

		if (weeks < 5) {
			return `${weeks} week${weeks === 1 ? "" : "s"} ago`;
		}

		const months = Math.floor(days / 30);

		if (months < 12) {
			return `${months} month${months === 1 ? "" : "s"} ago`;
		}

		// Math.max: con 360 dias la division por 365 da 0 y saldria "0 years ago".
		const years = Math.max(1, Math.floor(days / 365));

		return `${years} year${years === 1 ? "" : "s"} ago`;
	}

	// El mismo publisher puesto en dos grupos del proyecto recibe el correo dos
	// veces, y en esta pantalla no hay forma de verlo: cada grupo se edita por
	// separado. Devuelve el otro grupo que ya lo incluye, para avisarlo.
	//
	// "Otro" es cualquiera distinto del que esta abierto en el modal; un grupo
	// nuevo tiene id 0, asi que entonces cuentan todos.
	publisherOtherGroup = (publisher) => {
		const {selectedSubmissionList} = this.state;
		const current_id = selectedSubmissionList ? selectedSubmissionList.id : 0;
		const keys = this.publisherContactKeys(publisher);

		let match = null;

		(this.state.submissionLists || []).forEach(list => {
			if (list.id === current_id) {
				return;
			}

			const found = (list.contacts || []).some(
				contact => keys.has(`${contact.contact_type}-${contact.contact_id}`)
			);

			if (!found) {
				return;
			}

			// Enviado gana a agendado, y agendado a pendiente: si el publisher esta
			// en varios grupos, el que hay que reportar es el mas comprometido. Un
			// duplicado ya enviado no se deshace; uno agendado todavia se cancela.
			if (!match || this.groupStateRank(list) > this.groupStateRank(match)) {
				match = list;
			}
		});

		return match;
	}

	// ----------------------------------------------------
	// DUPLICADOS DEL DASHBOARD ---------------------------
	// ----------------------------------------------------

	// Que publishers quedaron repartidos en mas de un grupo, y en cuantos. La
	// tarjeta del modal avisa de uno en uno mientras se arma un grupo; esto es
	// la foto completa del proyecto, para verla antes de darle a Send All.
	//
	// Va con un indice inverso clave-de-contacto -> publisher en vez de buscar
	// el publisher de cada contacto entre los 250+ de la lista: esto se
	// recalcula en cada render.
	duplicatedPublishers = () => {
		const lists = this.state.submissionLists || [];
		const publishers = this.state.publishers || [];

		if (lists.length < 2 || !publishers.length) {
			return [];
		}

		const owner = new Map();

		publishers.forEach(publisher => {
			this.publisherContactKeys(publisher).forEach(key => owner.set(key, publisher));
		});

		const counts = new Map();

		lists.forEach((list, index) => {
			// Se guarda el numero de la columna Number Group, o sea la posicion de
			// la fila: es el que el usuario tiene delante en la tabla. Sale del
			// mismo array y en el mismo orden, asi que los dos siempre coinciden.
			const number = index + 1;

			// Un grupo cuenta una sola vez por publisher aunque lleve a varias de
			// sus personas: lo que se repite es el publisher, no cada contacto.
			const seen = new Set();

			(list.contacts || []).forEach(contact => {
				const publisher = owner.get(`${contact.contact_type}-${contact.contact_id}`);

				if (!publisher || seen.has(publisher.id)) {
					return;
				}

				seen.add(publisher.id);

				const entry = counts.get(publisher.id);

				if (entry) {
					entry.numbers.push(number);
				} else {
					counts.set(publisher.id, {publisher, numbers: [number]});
				}
			});
		});

		// Primero el mas repetido, que es el que mas correos duplicados genera.
		// Los numeros ya salen ordenados: se van anadiendo recorriendo las filas.
		return Array.from(counts.values())
			.filter(entry => entry.numbers.length > 1)
			.sort((a, b) =>
				b.numbers.length - a.numbers.length ||
				(a.publisher.name || "").localeCompare(b.publisher.name || "")
			);
	}

	// Un grupo esta listo para salir cuando tiene mensaje escrito. Los archivos
	// no cuentan: se activan y desactivan en caliente desde Unlock Files y no
	// deciden si el correo puede salir.
	//
	// El mensaje viene del editor, asi que no basta con mirar si la cadena esta
	// vacia: al borrar todo el contenido deja "<p>&nbsp;</p>", que como texto no
	// es nada pero como cadena mide 14 caracteres.
	hasMessage = (list) => {
		const message = (list && list.message) || "";

		// Una imagen sola tambien es un mensaje: el cuerpo por defecto que arma
		// openMessageModal es texto mas el banner, y alguien puede dejar solo el
		// banner. Quitar las etiquetas lo dejaria en nada y bloquearia un envio
		// perfectamente valido.
		if (/<img\b/i.test(message)) {
			return true;
		}

		return message.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim().length > 0;
	}

	// Lo que Send All va a mandar: pendientes y configurados. Los agendados ya
	// tienen hora propia y volver a encolarlos los duplicaria.
	dispatchableLists = () => (this.state.submissionLists || []).filter(
		list => !list.sent_at && !list.scheduled_at && this.hasMessage(list)
	)

	// Pendientes que se quedan fuera por no tener mensaje. Se nombran en la
	// confirmacion: un conteo sin decir cuales obliga a buscarlos a mano.
	unconfiguredLists = () => (this.state.submissionLists || []).filter(
		list => !list.sent_at && !list.scheduled_at && !this.hasMessage(list)
	)

	// El numero de fila de un grupo, el mismo de la columna Number Group.
	listNumber = (list) => {
		if (!list) {
			return 0;
		}

		return (this.state.submissionLists || []).findIndex(item => item.id === list.id) + 1;
	}

	// Repetidos que afectan a un grupo concreto: sus publishers que ademas estan
	// en otro. Se nombran los otros numeros, no el propio.
	listDuplicates = (list) => {
		const number = this.listNumber(list);

		if (!number) {
			return [];
		}

		return this.duplicatedPublishers()
			.filter(entry => entry.numbers.includes(number))
			.map(entry => ({
				publisher: entry.publisher,
				numbers: entry.numbers.filter(item => item !== number)
			}));
	}

	// Repetidos que afectan a una tanda: basta con que una de las apariciones
	// del publisher caiga dentro de lo que se va a mandar para que reciba el
	// mismo correo dos veces.
	dispatchDuplicates = (lists) => {
		const numbers = new Set((lists || []).map(this.listNumber));

		return this.duplicatedPublishers().filter(
			entry => entry.numbers.some(number => numbers.has(number))
		);
	}

	// "1 and 2" con dos, "1, 2 and 3" de tres en adelante.
	formatGroupNumbers = (numbers) => {
		if (numbers.length === 1) {
			return `${numbers[0]}`;
		}

		return `${numbers.slice(0, -1).join(", ")} and ${numbers[numbers.length - 1]}`;
	}

	// Bloque de repetidos para las confirmaciones de enviar y agendar. `entries`
	// ya viene con los numeros que toca nombrar en cada caso: todos los grupos
	// cuando es una tanda, los otros cuando es un grupo suelto.
	renderDuplicateConfirm = (entries, intro) => {
		if (!entries.length) {
			return null;
		}

		return (
			<div className="confirm-duplicates">
				<p className="confirm-duplicates-headline">{intro}</p>

				<div className="confirm-duplicates-list">
					{entries.map(entry => (
						<p className="confirm-duplicates-row" key={`confirm-duplicate-${entry.publisher.id}`}>
							{`${entry.publisher.name || entry.publisher.contact_name || "Unknown publisher"} - groups ${this.formatGroupNumbers(entry.numbers)}`}
						</p>
					))}
				</div>

				<p className="confirm-duplicates-note">
					They will receive the same email more than once.
				</p>
			</div>
		);
	}

	// Resumen que va entre "Add Message Group" y los botones de salir/enviar:
	// es el ultimo punto donde todavia se puede corregir un grupo antes de que
	// el correo salga.
	renderDuplicateSummary = () => {
		// Nada que resumir mientras la tabla carga o fallo, y nada que decir si
		// los publishers no estan cargados: sin ellos no se puede saber si hay
		// repetidos, y afirmar que no los hay seria mentir.
		if (this.state.loading_lists || this.state.lists_error !== "") {
			return null;
		}

		if (!(this.state.publishers || []).length) {
			return null;
		}

		const duplicated = this.duplicatedPublishers();

		if (!duplicated.length) {
			return (
				<div className="duplicate-summary is-clean">
					<p className="duplicate-headline">No publishers are repeated. All in order.</p>
				</div>
			);
		}

		const total = duplicated.length;

		return (
			<div className="duplicate-summary">
				<p className="duplicate-headline">
					{`${total} publisher${total === 1 ? "" : "s"} ${total === 1 ? "is" : "are"} in more than one message group`}
				</p>

				{/* Con scroll propio: una tanda con muchos repetidos no puede empujar
				    los botones de Exit y Send All fuera de la pantalla. */}
				<div className="duplicate-list">
					{duplicated.map(entry => (
						<p className="duplicate-row" key={`duplicate-${entry.publisher.id}`}>
							{`${entry.publisher.name || entry.publisher.contact_name || "Unknown publisher"} is repeated in groups ${this.formatGroupNumbers(entry.numbers)}`}
						</p>
					))}
				</div>
			</div>
		);
	}

	// Los tres estados de un grupo, los mismos que distingue la columna Schedule.
	groupStateRank = (list) => {
		if (list.sent_at) {
			return 2;
		}

		return list.scheduled_at ? 1 : 0;
	}

	// Las tres dan por sabido que el publisher ya esta en otro grupo; lo que
	// cambia es en que estado esta ese otro grupo, que es lo que decide si hay
	// algo que hacer al respecto y que.
	otherGroupLabel = (list) => {
		if (list.sent_at) {
			return "This publisher and their contacts have already been sent in another message group.";
		}

		if (list.scheduled_at) {
			return "This publisher and their contacts are scheduled to be contacted in another message group.";
		}

		return "This publisher and their contacts are already in another message group, waiting to be sent.";
	}

	// Quitar es quitar, no alternar. toggleAllPublisherContacts decide por
	// !allChecked, y allChecked exige que esten marcados la compania y todas sus
	// personas: sobre un publisher al que le faltara una, el boton Remove lo
	// dejaba completamente seleccionado en lugar de sacarlo de la lista.
	removePublisherFromSelection = async (publisher) => {
		await this.toggleSelectContact('publisher', publisher.id, publisher.email, false);

		for (const collaborator of (publisher.collaborators || [])) {
			await this.toggleSelectContact('publisher_employee', collaborator.id, collaborator.email, false);
		}
	}

	// ----------------------------------------------------
	// BUSCADOR -------------------------------------------
	// ----------------------------------------------------

	onSearchChange = (e) => {
		this.setState({search: e.target.value});
	}

	// El buscador es un <form>. Sin preventDefault, Enter o el boton de la lupa
	// lo envian y recargan la SPA, cerrando el modal y perdiendo la seleccion.
	// El filtrado ya ocurre al teclear, asi que el submit no tiene que hacer nada.
	onSearchSubmit = (e) => {
		e.preventDefault();
	}

	// Se filtra en el momento de render a partir del texto, en vez de guardar una
	// lista ya filtrada: asi no queda un filtro viejo pegado al reabrir el modal,
	// y la misma funcion sirve para publishers y para categorias de prensa.
	filterBySearch = (items) => {
		const term = (this.state.search || "").trim().toLowerCase();

		if (!term) {
			return items;
		}

		return items.filter(item => {
			// Coercion defensiva: un publisher sin tags hacia reventar el filtro y,
			// como el error caia en un catch, la busqueda dejaba de responder entera.
			const name = (item.name || "").toLowerCase();
			const tags = (item.tags || "").toLowerCase();

			return name.includes(term) || tags.includes(term);
		});
	}

	loadPublisherCollaboratorsCC = async (publisher) => {
		const collaboratorsRequest = await api.get(`publishers/${publisher.id}/employeescc`)
		publisher.collaborators = collaboratorsRequest.data || []

		return publisher.collaborators
	}

	// ----------------------------------------------------
	// LOAD CONTACT LIST ----------------------------------
	// ----------------------------------------------------
	loadCategories = async (company_id) => {
		try {
			const response = await api.get(`companies/${company_id}/presses`);
			const categories = response.data || []
			await this.loadContacts(categories);

			const newCategories = categories.map(category => {
				const newCategory = {
					company_id: category.company_id,
					contact_name: category.name,
					name: category.name,
					email: "",
					id: category.id,
					collaborators: category.contacts
				}

				return newCategory;
			})

			return this.setState({
				categories: newCategories,
				checkedItens: []
			});
		} catch (error) {
			console.log(error);
		}
	}
	
	loadContacts = async (categories) => {
		try {
			const contactsPromises = categories.map(this.loadCategoriesContacts)
			return Promise.all(contactsPromises);
		} catch (error) {
			console.log(error);
		}
	}

	loadCategoriesContacts = async (category) => {
		const { company_id } = this.state;
		const contactsRequest = await api.get(`companies/${company_id}/presses/${category.id}/contacts`)
		category.contacts = contactsRequest.data || []

		return category.contacts
	}
	

	// `silent` evita encender el loader: los refrescos automaticos mientras hay
	// grupos en cola no deben hacer parpadear la tabla cada pocos segundos.
	loadLists = async (silent) => {
		if (!silent) {
			this.setState({loading_lists: true, lists_error: ""});
		}

		try {
			const {company_id, project_id} = this.state
			const responseList = await api.get(`/companies/${company_id}/projects/${project_id}/submission-lists`)

			const submissionLists = responseList.data || []
			const contactsPromises = submissionLists.map(this.loadSubmissionListContacts)
			let contacts = await Promise.all(contactsPromises);

			// Los ids salen de la respuesta completa, antes del filtro: un grupo sin
			// contactos sigue existiendo en la API y no debe darse por borrado.
			const live_ids = new Set(submissionLists.map(list => list.id));

			// Un grupo sin contactos se oculta, pero uno cuyos contactos no se
			// pudieron cargar no es un grupo vacio: se queda visible para no dar por
			// desaparecido algo que si existe en la API.
			const tempList = submissionLists.filter(item => item.contacts.length > 0 || item.contacts_failed);

			this.setState({
				submissionLists: tempList,
				contacts
			});

			this.syncHistoryArchive(tempList, live_ids);

			// Los objetos de lista vienen nuevos y sin `files`, asi que lo que el
			// historial tuviera cacheado ya no esta pegado a ellos. Si el panel esta
			// abierto se repiten las peticiones en silencio para que no parpadee con
			// cada refresco automatico de la cola.
			this.history_files_ready = false;

			if (this.state.history_open) {
				await this.loadHistoryFiles(true);
			}
		} catch (error) {
			console.log(error);
			this.setState({
				submissionLists: [],
				lists_error: "The message groups could not be loaded. Please try again."
			});
		} finally {
			// Apagar el loader pase lo que pase. Dejarlo encendido en el catch era
			// lo que convertia cualquier fallo de la API en un spinner eterno sin
			// mensaje ni forma de reintentar.
			this.setState({loading_lists: false});
			this.syncQueueWatcher();
		}
	}
	

	// Un fallo aislado no puede tumbar la tabla entera: sin este catch el rechazo
	// subia al Promise.all de loadLists, caia en su catch y dejaba submissionLists
	// vacio tras el cartel de error, como si el proyecto no tuviera ni un grupo.
	loadSubmissionListContacts = async (submissionList) => {
		try {
			const contactsRequest = await api.get(`/project_submission_lists/${submissionList.id}/contacts`)
			submissionList.contacts = contactsRequest.data || []
			submissionList.contacts_failed = false
		} catch (error) {
			console.log(error);
			submissionList.contacts = []
			submissionList.contacts_failed = true
		}

		return submissionList.contacts;
	}

	onChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	async setSelectedSubmissionList (selectedSubmissionList) {
		return this.setState({
			selectedSubmissionList
		})
	}

	// Functions to modal Publisher
	async modalPublishers (status, submissionList = null) {
		// Cerrar no debe rehacer la ruta de apertura: hacerlo reemplazaba la lista
		// seleccionada por una vacia con id 0 y tiraba la seleccion en curso.
		if (status !== 'opened') {
			return this.setState({modal_publishers: 'closed'});
		}

		await this.setSelectedSubmissionList(submissionList || this.newSubmissionListObject())
		const {selectedSubmissionList} = this.state
		const {contacts} = selectedSubmissionList

		// Objeto, no array: el resto del codigo lo indexa por clave de contacto.
		// Y el buscador arranca limpio en cada apertura.
		await this.setState({
			selectedContacts: {},
			search: ""
		})

		for (const contact of contacts) {
			await this.toggleSelectContact(contact.contact_type, contact.contact_id, contact.contact_email, true)
		}

		this.setState({
			// new_list: id === 0 ? true : false,
			modal_publishers: status,
			// selected_list: id
		});
	}

	closePublishersModal () {
		// El boton puede no estar (el modal ya se desmonto): cerrar no puede lanzar,
		// o el modal se queda abierto justo por intentar cerrarlo.
		const saveButton = document.querySelector('.modal-list-publishers .save-container .link');

		if (saveButton) {
			saveButton.classList.remove("load");
		}

		this.setState({
			modal_publishers: 'closed'
		})
	}

	async toggleSelectContact (contact_type, contact_id, contact_email, forceSelected = null) {
		const selectedContacts = { ...this.state.selectedContacts }
		const contactKey = `${contact_type}-${contact_id}`
		const contact = selectedContacts[contactKey]
		const newCheckedState = forceSelected !== null ? forceSelected : !!contact === false

		if (!newCheckedState) {
			delete selectedContacts[contactKey]
		} else {
			selectedContacts[contactKey] = {
				contact_type,
				contact_id,
				contact_email
			}
		}

		this.setState({
			selectedContacts
		})
	}

	toggleListType = (type) => {
		this.setState({ type_list: type })
	}

	async toggleAllPublisherContacts(publisher) {
		const allChecked = this.publisherAllContactsSelected(publisher);
		const collaborators = publisher.collaborators || [];

		await this.toggleSelectContact('publisher', publisher.id, publisher.email, !allChecked);

		for (const collaborator of collaborators) {
			await this.toggleSelectContact('publisher_employee', collaborator.id, collaborator.email, !allChecked);
		}

		// No hay nada mas que actualizar: el badge "Selected" y la pestana de
		// seleccionados se derivan de selectedContacts, que es lo que acaba de
		// cambiar. Mantener ademas una lista propia era lo que las desincronizaba.
	}

	publisherAllContactsSelected (publisher) {
		const {selectedContacts} = this.state
		// collaborators queda sin asignar si su peticion fallo al cargar.
		const collaborators = publisher.collaborators || []
		const checkedPublisherCollaborators = collaborators.filter(
			collaborator => 
				!!selectedContacts[`publisher_employee-${collaborator.id}`]
			)
		const allChecked = checkedPublisherCollaborators.length === collaborators.length && !!selectedContacts[`publisher-${publisher.id}`]
		return allChecked
	}

	async toggleAllCategoryContacts (category) {
		const allChecked = this.categoryAllContactsSelected(category)
		for (const collaborator of (category.collaborators || [])) {
			await this.toggleSelectContact('press_contact', collaborator.id, collaborator.email, !allChecked)
		}
	}

	categoryAllContactsSelected (category) {
		const {selectedContacts} = this.state
		const collaborators = category.collaborators || []
		const checkedCategoryContacts = collaborators.filter(
			collaborator => 
				!!selectedContacts[`press_contact-${collaborator.id}`]
			)
		// Una categoria vacia no esta "toda seleccionada": sin esto, 0 === 0 la
		// pintaba marcada.
		const allChecked = collaborators.length > 0 && checkedCategoryContacts.length === collaborators.length
		return allChecked
	}

	async insertContact (submission_list_id, contact) {
		try {
			const response = await api.post(`/project_submission_lists/${submission_list_id}/contacts`, contact)
			return response.data
		} catch (error) {
			console.log(error);
		}
	}

	async removeContact (contact) {
		if (contact.id && contact.list_id) {
			try {
				const response = api.delete(`/project_submission_lists/${contact.list_id}/contacts/${contact.id}`)
				
				return response
			} catch (error) {
				console.log(error);
			}
		}
	}

    async saveListContacts () {
			const saveButton = document.querySelector('.modal-list-publishers .save-container .link');

			if (saveButton) {
				saveButton.classList.add("load");
			}

			let {selectedSubmissionList, selectedContacts} = this.state
			const contactsWithEmail = Object.values(selectedContacts).filter(contact => contact.contact_email)
			const contacts2Delete = selectedSubmissionList.contacts.filter(oldContact => !!selectedContacts[`${oldContact.contact_type}-${oldContact.contact_id}`] === false)
			const contacts2Insert = contactsWithEmail.filter(
				selectedContact => !!selectedSubmissionList.contacts.find(
					old => old.contact_id === selectedContact.contact_id && old.contact_type === selectedContact.contact_type
				) === false
			)

			if (!contacts2Insert.length && !contacts2Delete.length) {
				this.closePublishersModal()
				return;
			}
			
			// Todo el guardado va protegido: antes, cualquier fallo aqui dejaba la
			// promesa rechazada sin manejar, el boton girando con la clase "load" y
			// el modal abierto para siempre, sin decir nada. Daba la impresion de que
			// no se podian crear grupos.
			try {
				if (selectedSubmissionList.id === 0) {
					selectedSubmissionList = await this.saveNewList()

					// saveNewList se traga el error de la API y devuelve undefined: sin
					// esta guarda, el .id de la linea siguiente lanzaba.
					if (!selectedSubmissionList || !selectedSubmissionList.id) {
						throw new Error("The message group could not be created.");
					}
				}

				const insertPromises = contacts2Insert.map(contact => this.insertContact(selectedSubmissionList.id, contact))
				const deletePromises = contacts2Delete.map(this.removeContact)

				await Promise.all([...insertPromises, ...deletePromises])
				await this.loadLists()
				this.closePublishersModal()
			} catch (error) {
				console.log(error);

				if (saveButton) {
					saveButton.classList.remove("load");
				}

				// El modal se queda abierto a proposito: la seleccion no se ha perdido
				// y se puede reintentar sin volver a marcarlo todo.
				this.setState({schedule_error: "The message group could not be saved. Please try again."});
			}
    }

	closeMessageModal () {
		document.querySelector('.modal-write-message .btn-save').classList.remove("load");

		console.log("closeMessageModal");
		this.setState({
			subject: "",
			cc:"",
			message: "",
			modal_message: 'closed'
		})
	}

	openMessageModal (submissionList) {
		const {subject, cc, message} = submissionList
		this.setSelectedSubmissionList(submissionList)
		// console.log(submissionList);

		let temp_default_message = "";

		if(this.state.project_type === "finished"){
			temp_default_message = `It's my pleasure to bring your attention to <b>${this.state.project_title}</b> in development by <i>${this.state.company_name}.</i><br /><br /> You will find available the submission materials for your consideration by clicking on "View Details:"<br /><br />  <img src=${this.state.banner_src} width= "308px" height= "175px"></img>`
			this.setState({
				default_message:   `It's my pleasure to bring your attention to <b>${this.state.project_title}</b> in development by <i>${this.state.company_name}.</i><br /><br /> You will find available the submission materials for your consideration by clicking on "View Details:"<br /><br /> <img src=${this.state.banner_src} width= "308px" height= "175px"></img>`
			});
		} else if(this.state.project_type === "production") {
			temp_default_message = `It's my pleasure to bring your attention to <b>${this.state.project_title}</b> in development by <i>${this.state.company_name}.</i><br /><br /> You will find available the submission materials for your consideration by clicking on "View Details:"<br /><br /> <img src=${this.state.banner_src} width= "308px" height= "175px"></img>`
			this.setState({
				default_message: `It's my pleasure to bring your attention to <b>${this.state.project_title}</b> in development by <i>${this.state.company_name}.</i><br /><br /> You will find available the submission materials for your consideration by clicking on "View Details:"<br /><br />  <img src=${this.state.banner_src} width= "308px" height= "175px"></img>`
			}); 
		}

		this.setState({
			modal_message: 'opened',
			subject: subject || '',
			cc: cc || '',
			message: message || temp_default_message,
		})
	}

	modal_preview (submissionList) {
		const {subject, cc, message} = submissionList
		this.setSelectedSubmissionList(submissionList);

		this.setState({
			modal_preview: 'opened',
			preview_subject: subject || '',
			preview_cc: cc || '',
			preview_message: message || '',
		})
	}

	closePreviewEmailModal () {
		this.setState({
			preview_subject: "",
			preview_cc: "",
			modal_preview: 'closed'
		})
	}

	
	async saveMessage (e, status) {
		e.preventDefault();
		document.querySelector('.modal-write-message .btn-save').classList.add("load");
		var {selectedSubmissionList, project_id, subject, cc, default_message, message} = this.state

		//Elimina elementos Figure y Figcaption que se autoagregan al editar el correo cuando contiene una o varias imagenes
		while(message.indexOf('<figure class="image">') != -1)
		{
			message = message.slice(0,message.indexOf('<figure class="image">')) + message.slice(message.indexOf('<figure class="image">')+('<figure class="image">'.length),message.length)
			message = message.slice(0,message.indexOf('</figure>')) + message.slice(message.indexOf('</figure>')+('</figure>'.length),message.length)

			if(message.indexOf('<figcaption') != -1)
			{
				message = message.slice(0,message.indexOf('<figcaption')) + message.slice(message.indexOf('</figcaption>')+('</figcaption>'.length),message.length)

			}

		}

		try {
			await api.put(`/project_submission_lists/${selectedSubmissionList.id}`, {project_id, subject, cc, message})

			await this.loadLists();
			this.closeMessageModal();
		} catch (err) {
			console.log(err);
		}
	}

    async loadSubmissionListFiles (submissionList) {
        try {
            const response = await api.get(`/project_submission_lists/${submissionList.id}/files`);
            submissionList.files = response.data || []
            return submissionList.files
        } catch (err) {
            console.log(err)
        }
    }

	closeUnlockFilesModal () {
		document.querySelector('.modal-unlock-files .save-container .link').classList.remove("load");
		this.setState({
			modal_unlock_files: 'closed'
		});
	}

	async openUnlockFilesModal (submissionList) {
		await this.setSelectedSubmissionList(submissionList)
		await this.loadSubmissionListFiles(submissionList)

		let {available_links} = this.state
		available_links = submissionList.files.map(listFile => listFile.file_id)

		this.setState({
			modal_unlock_files: 'opened',
			available_links
		});
	}

	avaliableLink (link, status) {
		let available_links = [...this.state.available_links]
		const index = available_links.indexOf(link.id)
		if (index > -1) {
			available_links.splice(index, 1)
		}

		if (status) {
			available_links.push(link.id)
		}

		this.setState({
			available_links
		})
	}

	async saveNewList () {
		const { project_id } = this.state;
		try {
			const response = await api.post(`/project_submission_lists`, { project_id })

			return response.data
		} catch (error) {
			console.log(error);
		}
	}

    async insertFile (list_id, file_id) {
        try {
            return api.post(`/project_submission_lists/${list_id}/files`, {file_id})
        } catch (err) {
            console.log(err);
        }
    }

    async removeFile (listFile) {
        try {
            return api.delete(`/project_submission_lists/${listFile.list_id}/files/${listFile.id}`)
        } catch (err) {
            console.log(err);
        }
    }

	async saveAvaliableLinks () {
		document.querySelector('.modal-unlock-files .save-container .link').classList.add("load");
		const {available_links, selectedSubmissionList} = this.state;
		const _files2Remove = selectedSubmissionList.files.filter(listFile => !available_links.includes(listFile.file_id))
		const _files2Insert = available_links.filter(
			file_id => (!!selectedSubmissionList.files.find(listFile => listFile.file_id === file_id) === false)
		)

		const insertPromises = _files2Insert.map(file_id => this.insertFile(selectedSubmissionList.id, file_id))
		const deletePromises = _files2Remove.map(this.removeFile)
		const filesPromises = [...insertPromises, ...deletePromises]
		await Promise.all(filesPromises)
		this.closeUnlockFilesModal()
	}

	async deleteDataList (list_id) {
		try {
			return api.delete(`/project_submission_lists/${list_id}`);
		} catch (error) {
			console.log(error);
		}
	}

	//Functions to modal chat
	modal_chat (status) {
		this.setState({chat_modal: status});
	}

	//Functions to modal delete
	modalDelete (status, submissionList) {
    this.setSelectedSubmissionList(submissionList)
		this.setState({
			modal_delete: status
		});
	}

	modalconfirmStatus (Active, submissionList) {
		this.setState({
			modal_status: Active
		});
	}

	modalDetails (Details,id, submissionList) {
		this.setState({
			modal_details: Details,
			modal_details_id : id
		});
	}

	// Modal "More Info" de la columna Last Sent: muestra la fecha de envio y el
	// detalle de los contactos a los que se les envio esa lista.
	modalLastSent (status, submissionList = null) {
		this.setState({
			modal_last_sent: status,
			last_sent_target: status === "opened" ? submissionList : null
		});
	}

	// Agrupa los contactos de una lista por publisher / categoria para poder
	// listarlos con nombre y email dentro del modal de More Info.
	getSubmissionRecipients = (submissionList) => {
		const contacts = (submissionList && submissionList.contacts) || [];

		if (!contacts.length) {
			return [];
		}

		const hasContact = (contact_type, contact_id) => contacts.some(
			contact => contact.contact_type === contact_type && contact.contact_id === contact_id
		);

		const groups = [];

		(this.state.publishers || []).forEach(publisher => {
			const people = [];

			if (hasContact("publisher", publisher.id)) {
				people.push({
					key: `publisher-${publisher.id}`,
					name: publisher.contact_name || publisher.name || "",
					email: publisher.email || ""
				});
			}

			(publisher.collaborators || []).forEach(collaborator => {
				if (hasContact("publisher_employee", collaborator.id)) {
					people.push({
						key: `publisher_employee-${collaborator.id}`,
						name: collaborator.name || "",
						email: collaborator.email || ""
					});
				}
			});

			if (people.length) {
				groups.push({
					key: `publisher-group-${publisher.id}`,
					title: publisher.name || publisher.contact_name || "",
					people
				});
			}
		});

		(this.state.categories || []).forEach(category => {
			const people = [];

			(category.collaborators || []).forEach(collaborator => {
				if (hasContact("press_contact", collaborator.id)) {
					people.push({
						key: `press_contact-${collaborator.id}`,
						name: collaborator.name || "",
						email: collaborator.email || ""
					});
				}
			});

			if (people.length) {
				groups.push({
					key: `category-group-${category.id}`,
					title: category.name || "",
					people
				});
			}
		});

		return groups;
	};

	// El corte por falta de mensaje va aqui, antes de la confirmacion: no tiene
	// sentido preguntar "¿seguro?" por un envio que no puede ocurrir, y asi el
	// aviso dice lo que falta en vez de aparecer como un fallo de la API.
	modalconfirmSend (status, status2) {
		if (status === 'opened') {
			if (status2 !== 'all' && !this.hasMessage(status2)) {
				return this.setState({
					schedule_error: "This message group has no message written yet. Write the message before sending it."
				});
			}

			if (status2 === 'all' && this.dispatchableLists().length === 0) {
				return this.setState({schedule_error: this.nothingToSendMessage()});
			}
		}

		this.setState({
			modal_send: status,
			send_to: status2
		});
	}

	// Por que no hay nada que mandar: no es lo mismo haberlo enviado todo que
	// tener grupos a medio configurar esperando.
	nothingToSendMessage = () => {
		const blocked = this.unconfiguredLists();

		if (!blocked.length) {
			return "Every message group has already been sent or is queued.";
		}

		const numbers = this.formatGroupNumbers(blocked.map(this.listNumber));

		return blocked.length === 1
			? `Group ${numbers} has no message written yet. Write the message before sending it.`
			: `Groups ${numbers} have no message written yet. Write the messages before sending them.`;
	}
	
	modalconfirmSendClose () {
		this.setState({
			modal_send: 'closed'
		});
	}

	async deleteList (status) {
		const {selectedSubmissionList} = this.state
		this.setState({
			modal_delete: status
		})

		// Antes del delete: despues la API ya no devuelve ni el grupo ni sus
		// archivos, y el historial se quedaria sin ese envio.
		await this.archiveListBeforeDelete(selectedSubmissionList)

		await this.deleteDataList(selectedSubmissionList.id)
		this.setSelectedSubmissionList(null)
		this.loadLists()
	}

	// Devuelve si la API acepto el envio. El modal de "All Done" se pinta a partir
	// de esto: antes salia por el mero hecho de haber llamado, asi que un 500 se
	// anunciaba como envio correcto.
	async sendSubmissionListEmail (submissionList) {
		try {
			// await, no return: sin el, el catch de abajo nunca llega a ejecutarse.
			await api.post(`/project_submission_lists/${submissionList.id}/send`)

			return true
		} catch (err) {
			console.log(err)

			return false
		}
	}

	//Functions to send the project
	async sendToPublishers () {
		const recipients = this.state.send_to;
		const button = document.querySelector('.project-content .actions .btn-send');

		// "Send All" reparte solo los grupos que faltan y estan configurados:
		// reenviar uno ya enviado no alcanza a nadie, volver a encolar uno que ya
		// esta en cola lo duplicaria, y uno sin mensaje no tiene nada que mandar.
		const toDispatch = recipients === 'all' ? this.dispatchableLists() : [];

		if (recipients === 'all' && toDispatch.length === 0) {
			return this.setState({
				modal_send: "closed",
				schedule_error: this.nothingToSendMessage()
			});
		}

		if (button) {
			button.classList.add("load");
		}

		// Que salio de verdad, no cuantas llamadas se hicieron.
		let outcome = {queued: 0, failed: 0};

		try {
			if (recipients === 'all') {
				outcome = await this.dispatchAllStaggered(toDispatch);
			} else {
				const sent = await this.sendSubmissionListEmail(recipients);

				outcome = sent ? {queued: 1, failed: 0} : {queued: 0, failed: 1};
			}
		} catch (error) {
			console.log(error);
			outcome = {queued: 0, failed: toDispatch.length || 1};
		} finally {
			if (button) {
				button.classList.remove("load");
			}
		}

		this.setState({modal_send: "closed"});

		// El modal de exito solo cuando salio todo. Si fallo algo, el que manda es
		// el aviso de error: decir "All Done" sobre un envio que no ocurrio es peor
		// que no decir nada, porque nadie vuelve a intentarlo.
		if (outcome.failed > 0) {
			this.setState({
				schedule_error: outcome.queued > 0
					? `Only ${outcome.queued} of ${outcome.queued + outcome.failed} message groups could be sent. Please try the rest again.`
					: "The message could not be sent. Please try again."
			});

			return this.loadLists();
		}

		this.setState({modal_submitted: "opened"});
		setTimeout(() => {
			this.setState({
				modal_submitted: "closed"
			})
		}, 3000);
		return this.loadLists();
	}

	// ----------------------------------------------------
	// SCHEDULE -------------------------------------------
	// ----------------------------------------------------

	// <input type="datetime-local"> habla en hora local sin zona horaria, asi
	// que ambos sentidos de la conversion pasan por la zona del navegador: la
	// API siempre guarda y devuelve un instante UTC.
	toScheduleInputValue = (date) => {
		const pad = (n) => String(n).padStart(2, '0');

		return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
	}

	// Evita que el selector ofrezca un momento que la API rechazaria igual.
	minScheduleValue = () => this.toScheduleInputValue(new Date())

	// La zona del navegador se muestra junto a cada fecha: la API guarda instantes
	// UTC y cada navegador los traduce a la suya, asi que un "8:00 PM" a secas se
	// lee mal cuando quien agenda y quien revisa estan en paises distintos.
	browserTimeZone = () => {
		try {
			return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
		} catch (error) {
			return "";
		}
	}

	// Version larga para tooltips y modales: hora local, abreviatura de la zona
	// y nombre IANA entre parentesis.
	formatScheduleDate = (value) => {
		const date = new Date(value);

		if (isNaN(date.getTime())) {
			return "";
		}

		const zone = this.browserTimeZone();

		return `${date.toLocaleString(undefined, {timeZoneName: "short"})}${zone ? ` (${zone})` : ""}`;
	}

	// Version corta para el chip de la tabla, donde solo hay sitio para una
	// linea: "Oct 25, 12:00 PM GMT-6". Lleva la abreviatura de la zona en vez del
	// nombre IANA porque el chip recorta con ellipsis; el nombre completo queda en
	// el title, que usa formatScheduleDate.
	formatScheduleDateShort = (value) => {
		const date = new Date(value);

		if (isNaN(date.getTime())) {
			return "";
		}

		return date.toLocaleString(undefined, {
			month: "short",
			day: "numeric",
			hour: "numeric",
			minute: "2-digit",
			timeZoneName: "short"
		});
	}

	onScheduleChange = (list_id, value) => {
		this.setState({
			schedule_inputs: {
				...this.state.schedule_inputs,
				[list_id]: value
			}
		});
	}

	openScheduleModal = (submissionList) => {
		const value = this.state.schedule_inputs[submissionList.id];

		// Antes que la fecha: un grupo sin mensaje no se puede agendar aunque la
		// fecha sea correcta, y decirlo primero evita hacerle corregir la hora
		// para toparse con esto despues.
		if (!this.hasMessage(submissionList)) {
			return this.setState({
				schedule_error: "This message group has no message written yet. Write the message before scheduling it."
			});
		}

		if (!value) {
			return this.setState({schedule_error: "Pick a date and time first."});
		}

		if (new Date(value).getTime() <= Date.now()) {
			return this.setState({schedule_error: "The date and time must be in the future."});
		}

		this.setState({
			modal_schedule: "opened",
			schedule_target: submissionList
		});
	}

	closeScheduleModal = () => {
		this.setState({
			modal_schedule: "closed",
			schedule_target: null
		});
	}

	closeScheduleError = () => this.setState({schedule_error: ""})

	scheduleList = async () => {
		const {schedule_target, schedule_inputs} = this.state;

		if (!schedule_target) {
			return;
		}

		const list_id = schedule_target.id;
		const value = schedule_inputs[list_id];
		this.closeScheduleModal();

		try {
			const response = await api.post(`/project_submission_lists/${list_id}/schedule`, {
				scheduled_at: new Date(value).toISOString()
			});

			// La API responde 200 con {scheduled:false, error} cuando rechaza la fecha.
			if (response.data && response.data.scheduled === false) {
				return this.setState({schedule_error: response.data.error || "Could not schedule this message."});
			}

			await this.setState({
				schedule_inputs: {...this.state.schedule_inputs, [list_id]: ""}
			});

			return this.loadLists();
		} catch (error) {
			console.log(error);
			this.setState({schedule_error: "Could not schedule this message."});
		}
	}

	unscheduleList = async (submissionList) => {
		try {
			await api.post(`/project_submission_lists/${submissionList.id}/unschedule`);

			return this.loadLists();
		} catch (error) {
			console.log(error);
			this.setState({schedule_error: "Could not cancel the schedule."});
		}
	}

	// Tres estados excluyentes: agendado -> chip con boton de cancelar;
	// enviado -> chip con la fecha y hora del envio; ninguno -> selector.
	//
	// Una lista ya enviada no vuelve a ofrecer el selector. Tentaba mostrarlo
	// cuando quedaran contactos con sent_at nulo, pero ese campo no distingue
	// "pendiente" de "nunca se le envia": un contacto con setup "None" lo
	// conserva nulo para siempre, asi que la celda quedaria ofreciendo agendar
	// un envio que no alcanzaria a nadie. Para un seguimiento se crea un nuevo
	// grupo con "Add Message Group".
	renderScheduleCell = (submissionList) => {
		if (submissionList.scheduled_at) {
			return (
				<div className="schedule-field">
					<span className="schedule-chip" title={this.formatScheduleDate(submissionList.scheduled_at)}>
						<span className="schedule-dot"></span>
						<span className="schedule-chip-date">{this.formatScheduleDateShort(submissionList.scheduled_at)}</span>
					</span>
					<button
						className="schedule-icon-btn schedule-cancel"
						title="Cancel schedule"
						aria-label="Cancel schedule"
						onClick={(e) => this.unscheduleList(submissionList)}
					>
						<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18.3 5.7a1 1 0 0 0-1.4 0L12 10.6 7.1 5.7a1 1 0 1 0-1.4 1.4l4.9 4.9-4.9 4.9a1 1 0 1 0 1.4 1.4l4.9-4.9 4.9 4.9a1 1 0 0 0 1.4-1.4L13.4 12l4.9-4.9a1 1 0 0 0 0-1.4z"/></svg>
					</button>
				</div>
			);
		}

		if (submissionList.sent_at) {
			return (
				<div className="schedule-field">
					<span className="schedule-chip is-sent" title={`Sent ${this.formatScheduleDate(submissionList.sent_at)}`}>
						<span className="schedule-dot"></span>
						<span className="schedule-chip-date">{`Sent ${this.formatScheduleDateShort(submissionList.sent_at)}`}</span>
					</span>
				</div>
			);
		}

		return (
			<div className="schedule-field">
				<div className="schedule-input">
					<input
						type="datetime-local"
						name={`schedule-${submissionList.id}`}
						min={this.minScheduleValue()}
						value={this.state.schedule_inputs[submissionList.id] || ""}
						onChange={(e) => this.onScheduleChange(submissionList.id, e.target.value)}
					/>
				</div>
				<button
					className="schedule-icon-btn schedule-submit"
					title="Schedule"
					aria-label="Schedule"
					onClick={(e) => this.openScheduleModal(submissionList)}
				>
					<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 7v5l3.5 2.1.8-1.3-2.8-1.7V7H12z"/><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"/></svg>
				</button>
			</div>
		);
	}

	// ----------------------------------------------------
	// STAGGERED DISPATCH ---------------------------------
	// ----------------------------------------------------

	// Ventana de espera entre envios. Debe coincidir con SCHEDULER_MIN_GAP_MS y
	// SCHEDULER_MAX_GAP_MS del backend, que es quien la hace cumplir.
	//
	// Aqui solo sirve para repartir las horas de arranque de cada grupo. El
	// servidor ademas espera lo mismo entre una compania y la siguiente dentro
	// de cada grupo, asi que un grupo con varias companias termina mas tarde de
	// lo que sugiere su hora: esa hora es cuando empieza a salir, no cuando acaba.
	MIN_GAP_SECONDS = 30

	MAX_GAP_SECONDS = 50

	randomGapSeconds = () =>
		this.MIN_GAP_SECONDS + Math.floor(Math.random() * (this.MAX_GAP_SECONDS - this.MIN_GAP_SECONDS + 1))

	// Los tres conteos salen del estado que devuelve la API, no de una variable
	// local, para que el indicador sobreviva a una recarga y refleje lo que el
	// servidor realmente tiene en cola.
	queueCounts = () => {
		const lists = this.state.submissionLists || [];

		const queued = lists.filter(list => !!list.scheduled_at);
		const sent = lists.filter(list => !list.scheduled_at && !!list.sent_at);
		const pending = lists.filter(list => !list.scheduled_at && !list.sent_at);

		const nextAt = queued
			.map(list => new Date(list.scheduled_at).getTime())
			.filter(time => !isNaN(time))
			.sort((a, b) => a - b)[0];

		return {
			total: lists.length,
			queued: queued.length,
			sent: sent.length,
			pending: pending.length,
			nextAt: nextAt === undefined ? null : nextAt
		};
	}

	// Mientras queden grupos en cola, refrescar en silencio para que las filas
	// pasen solas de "agendado" a "enviado" sin que haya que recargar.
	syncQueueWatcher = () => {
		const {queued} = this.queueCounts();

		if (queued > 0 && !this.queueTimer) {
			this.queueTimer = setInterval(() => this.loadLists(true), 10000);
		} else if (queued === 0 && this.queueTimer) {
			clearInterval(this.queueTimer);
			this.queueTimer = null;
		}
	}

	// Envia el primer grupo al momento y le pone a los demas un agendado
	// escalonado, acumulando una espera aleatoria por grupo. Encolar en el
	// servidor en vez de esperar en el navegador significa que cerrar la
	// pestana no deja los grupos restantes sin salir.
	dispatchAllStaggered = async (lists) => {
		let offsetSeconds = 0;
		let queued = 0;
		let failed = 0;

		for (let i = 0; i < lists.length; i++) {
			const list = lists[i];

			this.setState({dispatch_progress: {done: i, total: lists.length}});

			try {
				if (i === 0) {
					await api.post(`/project_submission_lists/${list.id}/send`);
				} else {
					offsetSeconds += this.randomGapSeconds();

					const when = new Date(Date.now() + offsetSeconds * 1000);
					await api.post(`/project_submission_lists/${list.id}/schedule`, {
						scheduled_at: when.toISOString()
					});
				}

				queued += 1;
			} catch (error) {
				// Un grupo que falle no debe impedir que se encolen los siguientes,
				// pero si tiene que contarse: quien llama decide que avisar.
				console.log(error);
				failed += 1;
			}
		}

		this.setState({dispatch_progress: null});

		return {queued, failed};
	}

	// Indicador de la cabecera. Durante el reparto muestra el avance; en reposo,
	// cuantos grupos esperan en cola en el servidor o siguen sin enviarse.
	renderQueueIndicator = () => {
		const {dispatch_progress} = this.state;

		if (dispatch_progress) {
			return (
				<span className="queue-indicator is-working">
					{`Queuing ${dispatch_progress.done + 1} of ${dispatch_progress.total}...`}
				</span>
			);
		}

		const {total, queued, pending, nextAt} = this.queueCounts();

		if (total === 0) {
			return null;
		}

		if (queued > 0) {
			const next = nextAt ? ` - next ${this.formatScheduleDateShort(nextAt)}` : "";

			return (
				<span className="queue-indicator is-queued">
					{`${queued} group${queued === 1 ? "" : "s"} queued${next}`}
				</span>
			);
		}

		if (pending > 0) {
			return (
				<span className="queue-indicator">
					{`${pending} group${pending === 1 ? "" : "s"} pending`}
				</span>
			);
		}

		return <span className="queue-indicator is-done">All groups sent</span>;
	}

	// ----------------------------------------------------
	// ARCHIVO LOCAL DEL HISTORIAL ------------------------
	// ----------------------------------------------------

	// El formato y el almacenamiento viven en services/history-archive: Submission
	// History lee lo mismo que aqui se escribe. Aqui solo queda la parte que es de
	// esta pagina: mantenerlo al dia con la API y marcar lo que se borra.

	// El archivo se lee en cada render del panel, asi que se parsea una vez y se
	// guarda en memoria. La clave va en la cache porque el primer render ocurre
	// antes de que componentDidMount ponga el project_id.
	history_archive = null

	history_archive_key = null

	readHistoryArchive = () => {
		const key = archiveKey(this.state.project_id);

		if (this.history_archive && this.history_archive_key === key) {
			return this.history_archive;
		}

		this.history_archive_key = key;
		this.history_archive = readArchive(this.state.project_id);

		return this.history_archive;
	}

	writeHistoryArchive = (archive) => {
		this.history_archive_key = archiveKey(this.state.project_id);
		this.history_archive = archive;

		writeArchive(this.state.project_id, archive);
	}

	historySnapshot = (list) => snapshotList(list, this.state.project_id)

	// Vuelca al archivo los grupos enviados que devuelve la API y reconcilia: lo
	// que estaba guardado como vivo y ya no viene en la respuesta se borro en otra
	// sesion. `live_ids` sale de la respuesta SIN filtrar, porque loadLists
	// descarta los grupos que se quedaron sin contactos y esos no estan borrados.
	syncHistoryArchive = (lists, live_ids) => {
		const archive = this.readHistoryArchive();

		(lists || []).forEach(list => {
			if (!list.sent_at) {
				return;
			}

			const previous = archive[list.id];
			const snapshot = this.historySnapshot(list);

			// Los archivos se piden aparte y solo al desplegar el panel: mientras no
			// esten cargados hay que conservar los que ya se hubieran guardado.
			if (!list.files && previous) {
				snapshot.files = previous.files || [];
			}

			archive[list.id] = snapshot;
		});

		if (live_ids) {
			Object.keys(archive).forEach(key => {
				const entry = archive[key];

				if (entry && !entry.deleted && !live_ids.has(entry.id)) {
					// Consta que ya no esta, pero no cuando lo borraron.
					entry.deleted = true;
					entry.deleted_at = null;
				}
			});
		}

		this.writeHistoryArchive(archive);
	}

	// Guarda el grupo antes de que la API lo pierda. Si el panel de historial
	// nunca se abrio, sus archivos no estan cargados y se piden ahora: despues del
	// delete ya no queda a quien preguntarle.
	archiveListBeforeDelete = async (list) => {
		if (!list || !list.sent_at) {
			return;
		}

		const archive = this.readHistoryArchive();
		const previous = archive[list.id];

		if (!list.files) {
			try {
				const response = await api.get(`/project_submission_lists/${list.id}/files`);
				list.files = response.data || [];
			} catch (error) {
				console.log(error);
			}
		}

		const snapshot = this.historySnapshot(list);

		if (!list.files && previous) {
			snapshot.files = previous.files || [];
		}

		snapshot.deleted = true;
		snapshot.deleted_at = new Date().toISOString();

		archive[list.id] = snapshot;
		this.writeHistoryArchive(archive);
	}

	// ----------------------------------------------------
	// SENDING HISTORY ------------------------------------
	// ----------------------------------------------------

	// El panel nace plegado y solo pide los archivos de cada grupo la primera vez
	// que se despliega: es una peticion por grupo ya enviado y no tiene sentido
	// pagarlas mientras la tabla esta cerrada.
	toggleHistory = async () => {
		const opening = !this.state.history_open;

		this.setState({history_open: opening});

		if (opening && !this.history_files_ready) {
			await this.loadHistoryFiles();
		}
	}

	// Pide en paralelo los archivos de los grupos ya enviados. Un fallo aislado no
	// vacia el resto de la tabla, pero deja la cache sin marcar lista para que al
	// volver a abrir el panel se reintente en vez de quedarse con datos a medias.
	//
	// `silent` deja el spinner apagado: en un refresco de fondo la tabla ya tiene
	// datos en pantalla y taparla cada pocos segundos seria peor que esperar.
	loadHistoryFiles = async (silent) => {
		this.setState(silent ? {history_error: ""} : {history_loading: true, history_error: ""});

		const lists = (this.state.submissionLists || []).filter(list => !!list.sent_at);
		let failed = 0;

		await Promise.all(lists.map(async (list) => {
			try {
				const response = await api.get(`/project_submission_lists/${list.id}/files`);
				list.files = response.data || [];
			} catch (error) {
				console.log(error);
				list.files = list.files || [];
				failed += 1;
			}
		}));

		this.history_files_ready = failed === 0;

		// Ya con los archivos cargados, el archivo local guarda tambien cuales
		// fueron: si despues se borra el grupo, la columna Files Sent lo conserva.
		this.syncHistoryArchive(lists);

		this.setState({
			history_loading: false,
			history_error: failed ? "Some sent files could not be loaded. Collapse and open the history again to retry." : "",
			// Los archivos se escriben sobre el propio objeto de cada lista, asi que
			// la referencia de submissionLists no cambia: hay que forzar el repintado.
			render_update: !this.state.render_update
		});
	}

	// Compara dos fechas y conserva la mas reciente. Las invalidas se ignoran en
	// vez de propagarse como NaN hasta la celda.
	keepLatestDate = (current, value) => {
		if (!value) {
			return current;
		}

		const time = new Date(value).getTime();

		if (isNaN(time)) {
			return current;
		}

		if (!current || time > new Date(current).getTime()) {
			return value;
		}

		return current;
	}

	// Indice "contact_type-contact_id" -> destinatario de la tabla: a que fila va
	// y por cual de los dos canales entro. El contacto de tipo "publisher" es la
	// cuenta de la compania; los empleados y los contactos de prensa son personas,
	// y por eso alimentan columnas distintas.
	//
	// Se construye de una pasada en vez de buscar contacto por contacto: son 250+
	// publishers con sus empleados y la tabla se recalcula en cada render.
	buildHistoryIndex = () => {
		const index = new Map();

		(this.state.publishers || []).forEach(publisher => {
			const owner = {
				key: `publisher-${publisher.id}`,
				name: publisher.name || publisher.contact_name || "",
				type: "Publisher"
			};

			index.set(`publisher-${publisher.id}`, {
				...owner,
				channel: "company",
				label: publisher.contact_name || publisher.name || ""
			});

			(publisher.collaborators || []).forEach(employee => {
				index.set(`publisher_employee-${employee.id}`, {
					...owner,
					channel: "contact",
					label: employee.name || ""
				});
			});
		});

		(this.state.categories || []).forEach(category => {
			const owner = {
				key: `category-${category.id}`,
				name: category.name || category.contact_name || "",
				type: "Press"
			};

			(category.collaborators || []).forEach(employee => {
				index.set(`press_contact-${employee.id}`, {
					...owner,
					channel: "contact",
					label: employee.name || ""
				});
			});
		});

		return index;
	}

	// Los envios que alimentan la tabla: los grupos que la API sigue devolviendo,
	// mas los que el archivo local tiene marcados como borrados. Mandan los vivos,
	// que vienen recien traidos; el archivo solo aporta lo que ya no existe.
	//
	// Asi, si alguien limpia el localStorage, el historial pierde los borrados
	// pero conserva entero lo que si esta en la API.
	historyEntries = () => {
		const archive = this.readHistoryArchive();

		const live = (this.state.submissionLists || [])
			.filter(list => !!list.sent_at)
			.map(list => ({
				id: list.id,
				sent_at: list.sent_at,
				contacts: list.contacts || [],
				// Mientras el panel no se despliega los archivos no estan cargados;
				// los del archivo local sirven de relleno hasta que lleguen.
				files: list.files || (archive[list.id] && archive[list.id].files) || [],
				deleted: false,
				deleted_at: null
			}));

		const live_ids = new Set(live.map(entry => entry.id));

		const deleted = Object.keys(archive)
			.map(key => archive[key])
			.filter(entry => entry && entry.deleted && !live_ids.has(entry.id));

		return live.concat(deleted);
	}

	// Una fila por destinatario (publisher o categoria de prensa), no por grupo:
	// un mismo publisher puede aparecer en varios grupos y lo que interesa del
	// historial es su ultima fecha, no cada grupo por separado.
	//
	// Solo entran los grupos con sent_at. Los agendados o pendientes todavia no
	// son historial, y mezclarlos pintaria fechas de envios que no han ocurrido.
	buildHistoryRows = () => {
		const owners = this.buildHistoryIndex();
		const fileTitles = new Map((this.state.links || []).map(link => [link.id, link.title]));
		const rows = new Map();

		const rowFor = (owner) => {
			if (!rows.has(owner.key)) {
				rows.set(owner.key, {
					key: owner.key,
					name: owner.name || "Unknown",
					type: owner.type,
					company_sent_at: null,
					contact_sent_at: null,
					recipients: [],
					files: new Map(),
					send_ids: new Set(),
					deleted_sends: []
				});
			}

			return rows.get(owner.key);
		};

		this.historyEntries().forEach(entry => {
			(entry.contacts || []).forEach(contact => {
				const owner = owners.get(`${contact.contact_type}-${contact.contact_id}`);

				if (!owner) {
					return;
				}

				// sent_at del contacto es por destinatario y es lo mas fiel; cuando la
				// API no lo trae, la fecha del grupo es cuando salio el envio.
				const sent_at = contact.sent_at || entry.sent_at;

				if (!sent_at) {
					return;
				}

				const row = rowFor(owner);

				if (owner.channel === "company") {
					row.company_sent_at = this.keepLatestDate(row.company_sent_at, sent_at);
				} else {
					row.contact_sent_at = this.keepLatestDate(row.contact_sent_at, sent_at);
				}

				if (owner.label && !row.recipients.includes(owner.label)) {
					row.recipients.push(owner.label);
				}

				// Un grupo cuenta una sola vez por fila aunque le llegara a varios de
				// sus contactos: lo que se cuenta son envios, no destinatarios.
				if (!row.send_ids.has(entry.id)) {
					row.send_ids.add(entry.id);

					if (entry.deleted) {
						row.deleted_sends.push(entry);
					}
				}

				// Map por file_id: el mismo archivo repetido en dos grupos cuenta una vez.
				(entry.files || []).forEach(listFile => {
					row.files.set(listFile.file_id, fileTitles.get(listFile.file_id) || `File #${listFile.file_id}`);
				});
			});
		});

		return Array.from(rows.values())
			.map(row => ({
				...row,
				files: Array.from(row.files.values()),
				sends_total: row.send_ids.size,
				sends_deleted: row.deleted_sends.length,
				deleted_detail: row.deleted_sends
					.map(entry => entry.deleted_at
						? `Sent ${this.formatScheduleDateShort(entry.sent_at)}, deleted ${this.formatScheduleDateShort(entry.deleted_at)}`
						: `Sent ${this.formatScheduleDateShort(entry.sent_at)}, deleted from another session`)
					.join(" | "),
				this_game_sent_at: this.keepLatestDate(row.company_sent_at, row.contact_sent_at),
				// Pendiente de un endpoint de historial entre proyectos: con lo que
				// carga esta pagina solo se puede saber de este juego.
				any_game_sent_at: null
			}))
			.sort((a, b) => new Date(b.this_game_sent_at).getTime() - new Date(a.this_game_sent_at).getTime());
	}

	// Chip corto con la fecha y tooltip con la version larga, igual que la columna
	// Schedule del dashboard.
	renderHistoryDate = (value, empty_title) => {
		if (!value) {
			return <span className="history-empty" title={empty_title || ""}>--</span>;
		}

		return (
			<span className="history-chip" title={this.formatScheduleDate(value)}>
				{this.formatScheduleDateShort(value)}
			</span>
		);
	}

	// Estado del destinatario en el historial: si los grupos por los que recibio
	// este juego siguen existiendo o se borraron. Borrar un grupo no borra el
	// hecho de haberselo enviado, solo lo marca; las fechas de arriba se quedan.
	renderHistoryStatus = (row) => {
		if (!row.sends_deleted) {
			return <span className="history-status is-active">Active</span>;
		}

		if (row.sends_deleted === row.sends_total) {
			return <span className="history-status is-deleted" title={row.deleted_detail}>Deleted</span>;
		}

		// Label corto porque la columna es estrecha; el desglose va en el tooltip.
		return (
			<span className="history-status is-partial" title={row.deleted_detail}>
				{`${row.sends_deleted}/${row.sends_total} deleted`}
			</span>
		);
	}

	renderHistoryFiles = (files) => {
		if (!files.length) {
			return <span className="history-empty">--</span>;
		}

		return (
			<span className="badge history-files" title={files.join(", ")}>
				{`${files.length} file${files.length === 1 ? "" : "s"}`}
			</span>
		);
	}

	// Tabla plegable bajo el dashboard. Reusa las mismas piezas de la tabla de
	// arriba (title-content, project-content-header, publisher-selection) para que
	// las dos se lean como una sola pagina.
	renderHistory = () => {
		const open = this.state.history_open;
		// El conteo se calcula tambien con el panel plegado: asi la cabecera dice
		// si hay historial que mirar sin obligar a abrirlo. Las filas no dependen
		// de los archivos, que son lo unico que se pide al desplegar.
		const rows = this.buildHistoryRows();

		return (
			<div className="project-content row history-content">
				<button
					className={`title-content with-indicator history-toggle ${open ? "opened" : ""}`}
					onClick={this.toggleHistory}
					aria-expanded={open}
				>
					<span>Sending History</span>
					<span className="history-toggle-meta">
						{ !this.state.history_loading &&
							<span className="queue-indicator">
								{`${rows.length} recipient${rows.length === 1 ? "" : "s"}`}
							</span>
						}
						<span className="history-caret" aria-hidden="true"></span>
					</span>
				</button>

				{ open &&
					<React.Fragment>
						<div className="project-content-header history-header">
							<div className="col flex align-center sm-12 md-2 lg-2">
								<p className="title">Recipient</p>
							</div>
							<div className="col flex align-center sm-12 md-2 lg-2">
								<p className="title">Last Send To Company</p>
							</div>
							<div className="col flex align-center sm-12 md-2 lg-2">
								<p className="title">Last Send To Contact</p>
							</div>
							<div className="col flex align-center sm-12 md-1 lg-1">
								<p className="title">Files Sent</p>
							</div>
							<div className="col flex align-center sm-12 md-2 lg-2">
								<p className="title">This Game Sent</p>
							</div>
							<div className="col flex align-center sm-12 md-2 lg-2">
								<p className="title">Any Game Sent</p>
							</div>
							<div className="col flex align-center sm-12 md-1 lg-1">
								<p className="title">Status</p>
							</div>
						</div>

						{ this.state.history_loading &&
							<span className="laoding-lists"></span>
						}

						{ !this.state.history_loading &&
							<div className="project-content-body">
								{ this.state.history_error !== "" &&
									<div className="new-selection history-notice">
										<div className="col flex align-center sm-12">
											<p className="text">{this.state.history_error}</p>
										</div>
									</div>
								}

								{ rows.length === 0 &&
									<div className="new-selection history-notice">
										<div className="col flex align-center sm-12">
											<p className="text">No sends recorded for this game yet.</p>
										</div>
									</div>
								}

								{ rows.map(row => (
									<div
										className={`publisher-selection history-row ${row.sends_deleted === row.sends_total ? "is-deleted" : ""}`}
										key={row.key}
									>
										<div className="col flex align-center sm-12 md-2 lg-2 history-recipient">
											<p className="text" title={row.recipients.join(", ")}>{row.name}</p>
											<span className="badge-collabs history-type">{row.type}</span>
										</div>

										<div className="col flex align-center sm-12 md-2 lg-2">
											<span className="history-label">Last Send To Company</span>
											{this.renderHistoryDate(row.company_sent_at, "The company account has not received this game")}
										</div>

										<div className="col flex align-center sm-12 md-2 lg-2">
											<span className="history-label">Last Send To Contact</span>
											{this.renderHistoryDate(row.contact_sent_at, "No individual contact has received this game")}
										</div>

										<div className="col flex align-center sm-12 md-1 lg-1">
											<span className="history-label">Files Sent</span>
											{this.renderHistoryFiles(row.files)}
										</div>

										<div className="col flex align-center sm-12 md-2 lg-2">
											<span className="history-label">This Game Sent</span>
											{this.renderHistoryDate(row.this_game_sent_at)}
										</div>

										<div className="col flex align-center sm-12 md-2 lg-2">
											<span className="history-label">Any Game Sent</span>
											{this.renderHistoryDate(row.any_game_sent_at, "Cross-project history is not available yet")}
										</div>

										<div className="col flex align-center sm-12 md-1 lg-1">
											<span className="history-label">Status</span>
											{this.renderHistoryStatus(row)}
										</div>
									</div>
								))}
							</div>
						}
					</React.Fragment>
				}
			</div>
		);
	}


	renderCheck = (props) => {
		const {selectedContacts} = this.state;
		const key = `${props.contact_type}-${props.contact_id}`;
		let checked = !!selectedContacts[key] ? 'checked' : '';

		if (props.contact_type === 'publisher_all') {
			const publisher = (this.state.publishers || []).find(item => item.id === props.contact_id);
			checked = publisher && this.publisherAllContactsSelected(publisher) ? 'checked' : '';
		} else if (props.contact_type === 'press_contact_all') {
			const category = (this.state.categories || []).find(item => item.id === props.contact_id);
			checked = category && this.categoryAllContactsSelected(category) ? 'checked' : '';
		}

		// renderCheck se invoca dentro de .map(), asi que el boton que devuelve es
		// el elemento de la lista y necesita llevar la key el mismo.
		return (
			<button key={props.itemKey || `${key}-btn`} className={`check ${checked}`} onClick={props.onClick}>
				<p className="text">{props.label}</p>
			</button>
		);
	}

	// Tarjeta de la pestana "Publisher Selected". Recibe el grupo ajeno ya
	// calculado para no recorrer submissionLists otra vez por cada una.
	renderSelectedPublisher = ({publisher, otherGroup}) => {
		const lastSentAt = this.publisherLastSentAt(publisher);

		return (
		<div key={`selected-${publisher.id}`} className={`item selected-item ${otherGroup ? "is-duplicated" : ""}`}>
			<div className="item-head">
				<strong className="item-name">{publisher.name}</strong>
				{ publisher.tags && <span className="badge">{publisher.tags}</span> }
				<button
					className="btn-remove-selected"
					onClick={() => this.removePublisherFromSelection(publisher)}
				>
					Remove
				</button>
			</div>

			{/* Dos datos distintos, dos lineas. Esta responde "¿ya le llego este
			    proyecto?" y va en todas las tarjetas: para un publisher que solo
			    esta en este grupo la respuesta tambien importa. */}
			<p className={`selected-sent ${lastSentAt ? "" : "is-never"}`} title={lastSentAt ? this.formatScheduleDate(lastSentAt) : ""}>
				{ lastSentAt
					? `Last sent ${this.relativeSentLabel(lastSentAt)}.`
					: "This project was never sent to this publisher."
				}
			</p>

			{/* Y esta responde "¿lo tengo repetido?". Las tres variantes reconocen
			    que ya esta en otro grupo y se diferencian en que le va a pasar:
			    ya salio (no se deshace), va a salir sola (se cancela desde la
			    columna Schedule) o sigue esperando a que alguien la mande. */}
			{ otherGroup &&
				<p className="selected-warning">
					{ this.otherGroupLabel(otherGroup) }
				</p>
			}

			{/* Listar todos los contactos de la compania hacia pensar que tambien
			    recibirian el correo los que no estaban marcados. */}
			<div className="collaborators-list">
				{this.publisherSelectedPeople(publisher).map(person => (
					<p className="text" key={person.key}>
						{person.email ? `${person.name} (${person.email})` : person.name}
					</p>
				))}
			</div>
		</div>
		);
	}

	newSubmissionListObject () {
		return {
			id: 0,
			project_id: this.state.project_id,
			contacts: [],
		}
	}

	render() {
		const {state} = this
		const userType = this.state.user_type;

		let banner;
		if(this.state.banner_src) {
			banner = <img src={this.state.banner_src} alt={this.state.banner_title}/>
		} else {
			banner = <span className="without-banner">Without banner</span>
		}

		// Destinatarios de la lista abierta en el modal de "More Info" (Last Sent).
		const lastSentRecipients = this.state.last_sent_target
			? this.getSubmissionRecipients(this.state.last_sent_target)
			: [];

		// Pestana "Publisher Selected": se recalcula en cada render a partir de
		// selectedContacts, asi que siempre refleja el grupo que esta abierto.
		//
		// Se parte en dos bloques y el orden no es cosmetico: arriba lo que solo
		// vive en este grupo, que se puede dar por bueno sin mirar nada mas, y
		// debajo lo que ya viaja en otro y hay que decidir si se deja. El grupo
		// de cada publisher se calcula una vez aqui, no otra vez al pintar.
		const selectedEntries = this.selectedPublishersList().map(publisher => ({
			publisher,
			otherGroup: this.publisherOtherGroup(publisher)
		}));
		const selectedOnlyHere = selectedEntries.filter(entry => !entry.otherGroup);
		const selectedElsewhere = selectedEntries.filter(entry => entry.otherGroup);

		// Avisos de las confirmaciones. Se calculan solo con el modal abierto:
		// recorren todos los grupos y no hacen falta en un render normal.
		const sendSkipped = this.state.modal_send === 'opened' && this.state.send_to === 'all'
			? this.unconfiguredLists()
			: [];
		const sendDuplicates = this.state.modal_send === 'opened'
			? (this.state.send_to === 'all'
				? this.dispatchDuplicates(this.dispatchableLists())
				: this.listDuplicates(this.state.send_to))
			: [];
		const scheduleDuplicates = this.state.modal_schedule === 'opened'
			? this.listDuplicates(this.state.schedule_target)
			: [];

		//Unlock files butons
		const availableLinks = this.state.available_links;
		function LinkAvaliable(props) {
			const {link, onClickAvaliable, onClickUnavaliable} = props
			const available =  availableLinks.includes(link.id)//!!selectedSubmissionList.files.find(listFile => listFile.file_id === link.id)
			const bts = <div className="link-col" key={link.id}>
				<button onClick={onClickAvaliable} className={`btn grey ${available ? "avaliable" : ""}`}>Avaliable</button>
				<button onClick={onClickUnavaliable} className={`btn grey ${!available ? "unavaliable" : ""}`}>Unavaliable</button>
			</div>
			return bts
		}

		//List of contacts selecteds of Publishers
		function ButtonPublisherList (props) {
			
			const {submissionList} = props
			if (!submissionList.contacts.length) {
				return null;
			}

			const typesNameResolver = {
				publisher: (contact) => {
					const publisher = state.publishers.find((publisher) => publisher.id === contact.contact_id)
					if (publisher) {
						return publisher.contact_name || publisher.name || ''
					}
				},
				publisher_employee: (contact) => {
					for (const publisher of (state.publishers || [])) {
						const employee = (publisher.collaborators || []).find(collaborator => collaborator.id === contact.contact_id)
						if (employee) {
							return employee.name
						}
					}
					return ''
				},
				press_contact: (contact) => {
					// Las coerciones no son de adorno: categories no esta en el estado
					// inicial y queda sin asignar si loadCategories falla. Esto corre en
					// render y sin ellas la excepcion deja la pagina en blanco, que es
					// justo lo que podia pasar ahora que un admin si puede armar grupos
					// de prensa.
					for (const category of (state.categories || [])) {
						const employee = (category.collaborators || []).find(collaborator => collaborator.id === contact.contact_id)
						if (employee) {
							return employee.name
						}
					}
				}
			}

			const contactsName = submissionList.contacts.map((contact) => {
				const resolver = typesNameResolver[contact.contact_type]

				return (resolver && resolver(contact)) || ''
			})

			return <button className="link-col btn btn-publishers" key={submissionList.id} onClick={props.onClick}>
				{contactsName.join(', ')}
			</button>;	
		}
		
        return (
			<div data-page="project">
				<Header />

				<TitlePage title="Follow-Up Projects"/>

				
				<div className="container-fluid" data-component="project-content">
					<div className="container-fluid">
						<div className="project-header row">
							<h1 className="title">Dashboard of {this.state.project_title}</h1>
							<div className={`chat-modal ${this.state.chat_modal}`}>
								<div className="chat-container">
									<div className="chat-header">
										<p className="chat-name">Jhon Doe</p>
										<button onClick={e => this.modal_chat('closed')} className="btn btn-close"></button>
									</div>

									<div className="chat-content">
										<div className="message-received">
											<div className="profile-image">
												<img src={logoPartner} alt={`logo ${this.state.company_name}`}/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="project-content row">
							<div className="title-content with-indicator">
								<span>Message Center</span>
								{this.renderQueueIndicator()}
							</div>
							<div className="project-content-header">
								{/* El ancho que ocupa esta columna sale del de Last Sent, que
								    tenia lg-2 para un solo boton: en lg las columnas tienen que
								    seguir sumando 12 o dejan de cuadrar con las de las filas. */}
								<div className="col flex align-center col-group-number sm-2 md-1 lg-1">
									<p className="title">Number Group</p>
								</div>
								<div className="col flex align-center sm-10 md-5 lg-3">
									{ this.state.user_type === "admin" &&
										<p className="title">Publishers</p>
									}
									{ this.state.user_type === "normal" &&
										<p className="title">Contacts</p>
									}
								</div>
								<div className="col flex align-center sm-4 md-2 lg-1">
									<p className="title">Message</p>
								</div>
								<div className="col flex align-center sm-4 md-2 lg-1">
									<p className="title">Files to send</p>
								</div>
								<div className="col flex align-center sm-4 md-1 lg-1">
									<p className="title">Last Sent</p>
								</div>
								<div className="col flex align-center sm-4 md-2 lg-3">
									<p className="title">Actions</p>
								</div>
								<div className="col flex align-center sm-4 md-2 lg-2">
									<p className="title">Schedule</p>
								</div>
							</div>

							{ this.state.loading_lists &&
								<span className="laoding-lists"></span>
							}

							{ !this.state.loading_lists && this.state.lists_error !== "" &&
								<div className="project-content-body">
									<div className="new-selection">
										<div className="col flex align-center sm-12 md-8 lg-9">
											<p className="text">{this.state.lists_error}</p>
										</div>
										<div className="col flex align-center sm-12 md-4 lg-3">
											<button className="btn blue" onClick={(e) => this.loadLists()}>Retry</button>
										</div>
									</div>
								</div>
							}

							{ !this.state.loading_lists && this.state.lists_error === "" &&
								<div className="project-content-body">
									{ this.state.submissionLists.map((submissionList, index) => (
										<div className="publisher-selection has-schedule" key={submissionList.id}>
											{/* Numero de fila, no el id del grupo: sirve para referirse a
											    una fila al hablar del dashboard, y por eso cuenta desde 1
											    siguiendo el orden en que se ven. */}
											<div className="col flex align-center col-group-number sm-2 md-1 lg-1">
												<span className="group-number">{index + 1}</span>
											</div>
											<div className="col flex align-center sm-10 md-5 lg-3">
												<ButtonPublisherList id={submissionList.id} submissionList={submissionList} onClick={(e) => this.modalPublishers("opened", submissionList)}/>
											</div>
											<div className="col flex align-center sm-4 md-2 lg-1">
												<button className="btn-icon btn-message" onClick={(e) => this.openMessageModal(submissionList)} title="Write message">
													<svg xmlns="http://www.w3.org/2000/svg" viewBox="-21 -47 682.667 682"><path d="M552.012-1.332H87.988C39.473-1.332 0 38.133 0 86.656V370.63c0 48.414 39.3 87.816 87.676 87.988V587.48l185.191-128.863h279.145c48.515 0 87.988-39.472 87.988-87.988V86.656c0-48.523-39.473-87.988-87.988-87.988zm50.488 371.96c0 27.837-22.648 50.49-50.488 50.49h-290.91l-135.926 94.585v-94.586H87.988c-27.84 0-50.488-22.652-50.488-50.488V86.656c0-27.843 22.648-50.488 50.488-50.488h464.024c27.84 0 50.488 22.645 50.488 50.488zm0 0" data-original="#000000"/><path d="M171.293 131.172h297.414v37.5H171.293zm0 0M171.293 211.172h297.414v37.5H171.293zm0 0M171.293 291.172h297.414v37.5H171.293zm0 0" data-original="#000000"/></svg>
												</button>
											</div>

											<div className="col flex align-center col-files sm-3 md-2 lg-1">
												<button className="btn-icon btn-unlock" onClick={(e) => this.openUnlockFilesModal(submissionList)} title="Unlock Files">
													<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M334.974 0c-95.419 0-173.049 77.63-173.049 173.049 0 21.213 3.769 41.827 11.211 61.403L7.672 399.928a12.613 12.613 0 00-3.694 8.917v90.544c0 6.965 5.646 12.611 12.611 12.611h74.616a12.61 12.61 0 008.91-3.686l25.145-25.107a12.61 12.61 0 003.701-8.925v-30.876h30.837c6.965 0 12.611-5.646 12.611-12.611v-12.36h12.361c6.964 0 12.611-5.646 12.611-12.611v-27.136h27.136c3.344 0 6.551-1.329 8.917-3.694l40.121-40.121c19.579 7.449 40.196 11.223 61.417 11.223 95.419 0 173.049-77.63 173.049-173.049C508.022 77.63 430.393 0 334.974 0zm0 320.874c-20.642 0-40.606-4.169-59.339-12.393-4.844-2.126-10.299-.956-13.871 2.525-.039.037-.077.067-.115.106l-42.354 42.354h-34.523c-6.965 0-12.611 5.646-12.611 12.611v27.136H159.8c-6.964 0-12.611 5.646-12.611 12.611v12.36h-30.838c-6.964 0-12.611 5.646-12.611 12.611v38.257l-17.753 17.725H29.202v-17.821l154.141-154.14c4.433-4.433 4.433-11.619 0-16.051s-11.617-4.434-16.053 0L29.202 436.854V414.07l167.696-167.708c.038-.038.067-.073.102-.11 3.482-3.569 4.656-9.024 2.53-13.872-8.216-18.732-12.38-38.695-12.38-59.33 0-81.512 66.315-147.827 147.827-147.827S482.802 91.537 482.802 173.05c-.002 81.51-66.318 147.824-147.828 147.824z"/><path d="M387.638 73.144c-26.047 0-47.237 21.19-47.237 47.237s21.19 47.237 47.237 47.237 47.237-21.19 47.237-47.237-21.189-47.237-47.237-47.237zm0 69.252c-12.139 0-22.015-9.876-22.015-22.015s9.876-22.015 22.015-22.015 22.015 9.876 22.015 22.015-9.876 22.015-22.015 22.015z"/></svg>
												</button>
											</div>

											<div className="col flex align-center col-last-sent sm-3 md-1 lg-1">
												<button
													className="btn blue btn-more-info"
													onClick={(e) => this.modalLastSent("opened", submissionList)}
													title="Sending details"
												>
													More Info
												</button>
											</div>

											<div className="col flex align-center sm-5 md-3 lg-3 body-actions">
												<button className="btn blue" onClick={(e) => this.modal_preview(submissionList)}>Preview</button>
												<button className="btn blue btn-send" onClick={e => this.modalconfirmSend('opened',submissionList)}>Send Now</button>
												<button className="btn green" onClick={e => this.modalconfirmStatus('opened')}>Details</button>
												<button className="btn delete" onClick={(e) => this.modalDelete("opened", submissionList)}>Delete</button>
											</div>
											<div className="col flex align-center sm-12 md-12 lg-2">
												{this.renderScheduleCell(submissionList)}
											</div>
										</div>
									))}
								

									<div className="new-selection">
										<div className="col flex align-center sm-12 md-3 lg-3">
											<button className="btn blue" onClick={(e) => this.modalPublishers("opened")}>
												Add Message Group
											</button>
										</div>
									</div>
								</div>
							}

							{this.renderDuplicateSummary()}

							<div className="actions">
								<div className="col flex align-center sm-12 md-5 lg-6">
									<Link to={`/shipping-management/${this.state.company_id}/${this.state.project_id}`} className="btn">Exit</Link>
									{/* <Link to={`/email-scheduler/${this.state.company_id}/${this.state.project_id}`} className="btn" title="Schedule an Email">Schedule</Link>
									<a href="http://mailtrack.seat7entertainment.com/" target='_blank'><button className="btn">Track</button></a>
									*/}
									<button className="btn blue btn-send" onClick={e => this.modalconfirmSend('opened','all')}>Send All</button>
								</div>
							</div>
						</div>

						{this.renderHistory()}
					</div>
				</div>

        { this.state.modal_publishers === 'opened' && 
		<div data-component="modal" className={`modal-project-management opened`}>
			<div className="modal-container">
			<div className="modal-header">
				{ this.state.user_type === "admin" ? (
				<p className="text">Select Publishers</p>
				) : (
				<p className="text">Select Contacts</p>
				)}
				<button onClick={() => this.modalPublishers('closed')} className="btn btn-close"></button>
			</div>

			<div className="modal-content modal-list-publishers">
				<div className="list-publishers-header">
				{ this.state.user_type === "admin" && (
					<div>
					<button className={`btn toggle-type-list ${this.state.type_list === 'publishers' ? "is-active" : ""}`} onClick={() => this.toggleListType('publishers')}>
						Publisher List
					</button>
					<button className={`btn toggle-type-list ${this.state.type_list === 'selectedPublishers' ? "is-active" : ""}`} onClick={() => this.toggleListType('selectedPublishers')}>
						Publisher Selected
					</button>
					{/* Las categorias de prensa se cargan tambien para el admin, pero sin
					    este boton type_list nunca llegaba a "categories" y la lista era
					    inalcanzable: un admin no podia armar un grupo de prensa. */}
					<button className={`btn toggle-type-list ${this.state.type_list === 'categories' ? "is-active" : ""}`} onClick={() => this.toggleListType('categories')}>
						Contacts
					</button>

					&nbsp;
					</div>
				)}

				<div className="search">
					<Search onSubmit={this.onSearchSubmit} placeholder="Search" value={this.state.search} onChange={this.onSearchChange}/> 
				</div>
				</div>

				{/* Lista de publishers completos */}
				
					
					
					
				
				{this.state.type_list === "publishers" && (
					<div className="list-publishers-content new-list">
						{this.filterBySearch(this.state.publishers || []).map(publisher => {
						// Seleccionado = tiene algun contacto marcado para este grupo.
						const isSelected = this.publisherHasSelection(publisher);

						return (
							<div
							key={publisher.id}
							className={`item ${isSelected ? "selected-item" : ""}`}
							>
							{this.renderCheck({
								itemKey: `publisher-all-${publisher.id}`,
								onClick: () => this.toggleAllPublisherContacts(publisher),
								label: publisher.name,
								contact_type: "publisher_all",
								contact_id: publisher.id
							})}

							<button
								className="badge-details"
								onClick={() => this.modalDetails("opened", publisher.id)}
							>
								Details
							</button>
							&nbsp;
							<span className="badge">{publisher.tags}</span>
							&nbsp;
							{isSelected && <span className="badge" style={{ background: "#0a0" }}>Selected</span>}

							<br />
							<h5 style={{ color: "#1141de", padding: "1px" }}>Company Contacts</h5>
							<div>
								<span className="badge-collabs">
								{`${publisher.contact_name || publisher.name} - ${publisher.email}`}
								</span>
								<br />
								{publisher.collaborators && publisher.collaborators.length > 0 ? (
								publisher.collaborators.map((collaborator, index) => (
									<span
									className="badge-collabs"
									style={{ marginBottom: "2px" }}
									key={collaborator.email}
									>
									{`${collaborator.name} ( ${collaborator.email} )`}
									{index < publisher.collaborators.length - 1 && <br />}
									</span>
								))
								) : (
								<div>No collaborators</div>
								)}
								<br />
							</div>
							</div>
						);
						})}
					</div>
					)}

					{/* Lista de publishers seleccionados: solo los de este grupo, y de
					    cada uno solo los contactos marcados. Va en dos secciones para
					    que lo repetido en otros grupos quede abajo y se lea aparte. */}
					{this.state.type_list === "selectedPublishers" && (
					<div className="list-publishers-content new-list">
						{selectedEntries.length > 0 ? (
						<React.Fragment>
							{ selectedOnlyHere.length > 0 &&
								<React.Fragment>
									<h4 className="selection-title">Selected in this group</h4>
									{selectedOnlyHere.map(this.renderSelectedPublisher)}
								</React.Fragment>
							}

							{ selectedElsewhere.length > 0 &&
								<React.Fragment>
									<h4 className="selection-title is-secondary">Selected in other groups</h4>
									{selectedElsewhere.map(this.renderSelectedPublisher)}
								</React.Fragment>
							}
						</React.Fragment>
						) : (
						<div className="empty-selection">
							No publishers selected
						</div>
						)}
					</div>
					)}


				{/* Lista de categorías */}
				{this.state.type_list === "categories" && (
				<div className="list-publishers-content new-list">
					{this.filterBySearch(this.state.categories || []).map(publisher => (
					<div key={publisher.id} className="item">
						{this.renderCheck({
						itemKey: `press_contact-all-${publisher.id}`,
						onClick: () => this.toggleAllCategoryContacts(publisher),
						label: publisher.name,
						contact_type: 'press_contact_all',
						contact_id: publisher.id
						})}

						<div className="collaborators-list categories-list">
						{(publisher.collaborators || []).map(collaborator => (
							this.renderCheck({
							itemKey: `press_contact-${collaborator.id}`,
							onClick: () => this.toggleSelectContact('press_contact', collaborator.id, collaborator.email),
							label: `${collaborator.name} - ${collaborator.email}`,
							contact_type: 'press_contact',
							contact_id: collaborator.id
							})
						))}
						</div>
					</div>
					))}
				</div>
				)}

				<div className="save-container">
				<button className="link" onClick={() => this.saveListContacts()}>Save</button>
				</div>
			</div>
			</div>
		</div>
		}

				{this.state.modal_message === 'opened' &&
					<div data-component="modal" className={`modal-project-management opened`}>				
						<div className="modal-container">
							<div className="modal-header">
								<p className="text">Message</p>
								<button onClick={e => this.closeMessageModal()} className="btn btn-close"></button>
							</div>

							<div className="modal-content modal-write-message with-ck-editor">
								<form action="">
									<input
										id="subject"
										name="subject"
										type="text"
										placeholder="Subject:"
										//value={this.state.subject}
										value={this.state.subject || this.state.project_title + " " + "("+this.state.company_name + ")"}
										onChange={e => this.onChange(e)}
									/>
									  
									<CKEditor
										editor={ ClassicEditor }
										data={this.state.message}
										onChange={ ( event, editor ) => {
											const data = editor.getData();
											this.setState({message: data});
										}}
									/>
									<button type="submit" className="btn blue btn-save" onClick={(e) => this.saveMessage(e)}>Save</button>
								</form>
							</div>
						</div>
					</div>
				}
				{
					this.state.modal_unlock_files === 'opened' &&
					<div data-component="modal" className={`modal-project-management opened`}>
						<div className="modal-container">
							<div className="modal-header">
								<p className="text">Unlock Files</p>
								<button onClick={e => this.closeUnlockFilesModal()} className="btn btn-close"></button>
							</div>

							<div className="modal-content modal-unlock-files">
								<div className="files-header">
									<div className="col flex align-center sm-12 lg-3">
											<p className="title">Title</p>
									</div>
									<div className="col flex align-center sm-12 lg-5">
									<p className="title">Description</p>
									</div>
									<div className="col flex align-center header-action sm-12 lg-4">
											<p className="title">Action</p>
									</div>
								</div>
								<div className="list-files">
									{this.state.links.map(link => (
										<div className="link-container" key={`collaborator-${link.id}`}>
											<div className="col flex align-center sm-12 md-6 lg-3">
												<div className="link-col"><p className="text">{link.title}</p></div>
											</div>
											<div className="col flex align-center sm-12 md-12 lg-5">
												<div className="link-col description">
													<p className="text">{link.description}</p>
													<a href={link.file_url} target="blank" className="btn view">View</a>
												</div>
											</div>
											<div className="col flex align-center body-action sm-12 md-6 lg-4">
												<LinkAvaliable
													link={link}
													onClickAvaliable={e => this.avaliableLink(link, true)}
													onClickUnavaliable={e => this.avaliableLink(link, false)}
												/>
											</div>
										</div>
									))}
								</div>

								<div className="save-container">
									<button className="link" onClick={e => this.saveAvaliableLinks("closed")}>Save</button>
								</div>
							</div>
						</div>
					</div>
				}

				{ this.state.modal_preview === 'opened' &&
					<div data-component="modal" className={`modal-preview opened`}>
						<div className="content">
							<button onClick={e => this.closePreviewEmailModal()} className="btn btn-close"></button>
							<EmailPreview project_title={this.state.project_title} company={this.state.company_name} subject={this.state.preview_subject} cc={this.state.preview_cc} default_message={this.state.default_message} message={this.state.preview_message}/>
						</div>
					</div>
				}

				{ this.state.modal_send === 'opened' &&
					<div data-component="modal" className={`modal-cancel opened`}>
						<div className="content">
							<p className="text">
								You are about to send this email to the accounts selected. <br/>
								{ this.state.send_to === 'all' &&
									<span>
										The first group goes out now and the rest follow gradually: the
										server waits 30 to 50 seconds between one company and the next,
										so the delivery does not look like a burst to spam filters. A
										project with many companies can take a while to finish. You can
										close this page: the queue runs on the server. <br/>
									</span>
								}
								{/* Los pendientes sin mensaje no entran en la tanda. Se nombran
								    aqui porque es la ultima pantalla donde todavia se pueden
								    escribir antes de dar por enviado el proyecto. */}
								{ this.state.send_to === 'all' && sendSkipped.length > 0 &&
									<span className="skipped-note">
										{ sendSkipped.length === 1
											? `Group ${this.formatGroupNumbers(sendSkipped.map(this.listNumber))} will be skipped: it has no message written.`
											: `Groups ${this.formatGroupNumbers(sendSkipped.map(this.listNumber))} will be skipped: they have no message written.`
										}
										<br/>
									</span>
								}
								<span className="red-text">This action cannot be undone.</span> <br/>
								<b>Are you sure you want to continue?</b>
							</p>

							{this.renderDuplicateConfirm(
								sendDuplicates,
								this.state.send_to === 'all'
									? "Some publishers are in more than one of the groups being sent:"
									: "Some publishers in this group are also in other groups:"
							)}

							<button onClick={e => this.modalconfirmSendClose('closed')} className="btn grey">
								{ sendDuplicates.length > 0 ? "Cancel" : "No" }
							</button>
							<button onClick={(e) => this.sendToPublishers()} to="/projects" className="btn blue-light">
								{ sendDuplicates.length > 0 ? "Send anyway" : "Yes" }
							</button>
						</div>
					</div>
				}

				{ this.state.modal_schedule === 'opened' && this.state.schedule_target &&
					<div data-component="modal" className={`modal-cancel opened`}>
						<div className="content">
							<p className="text">
								This message will be sent automatically on <br/>
								<b>{this.formatScheduleDate(this.state.schedule_inputs[this.state.schedule_target.id])}</b>. <br/>
								You can cancel it from the Schedule column until then. <br/>
								<b>Are you sure you want to continue?</b>
							</p>

							{this.renderDuplicateConfirm(
								scheduleDuplicates,
								"Some publishers in this group are also in other groups:"
							)}

							<button onClick={e => this.closeScheduleModal()} className="btn grey">
								{ scheduleDuplicates.length > 0 ? "Cancel" : "No" }
							</button>
							<button onClick={e => this.scheduleList()} className="btn blue-light">
								{ scheduleDuplicates.length > 0 ? "Schedule anyway" : "Yes" }
							</button>
						</div>
					</div>
				}

				{ this.state.schedule_error !== "" &&
					<div data-component="modal" className={`modal-cancel opened`}>
						<div className="content">
							<h3 className="text">{this.state.schedule_error}</h3>
							<button onClick={e => this.closeScheduleError()} className="btn grey">Ok</button>
						</div>
					</div>
				}

				{ this.state.modal_status === 'opened' &&
					<div data-component="modal" className={`modal-cancel opened`}>
						<div className="content">
							<h3 className="text">
								Email is Active For The Selected Publishers.
							</h3>
							<button onClick={e => this.modalconfirmStatus('closed')} className="btn grey">Ok</button>
						</div>
					</div>
				}

				{ this.state.modal_details === 'opened' &&
					<div data-component="modal" className={`modal-cancel opened`}>
						<div className="content">
							<div className="text">
									<h4>
										Publisher's Contacts
									</h4>

									{ this.state.type_list === "publishers" &&
										<div className={`list-publishers-content new-list`}>
											{ this.state.publishers.map( publisher => (
												<div key={publisher.id} className={`item`}>
													{ this.state.user_type === "admin" && publisher.id == state.modal_details_id &&
														<div className="collaborators-list">
															{this.renderCheck({
																itemKey: `details-${publisher.id}`,
																label: `${publisher.contact_name} (${publisher.email})`
															})}
															<br/>
															{(publisher.collaborators || []).map(collaborator => (
																this.renderCheck({
																	itemKey: `details-collaborator-${collaborator.id}`,
																	label: `${collaborator.name} (${collaborator.email})`
																})
															))
															}
														</div>
													}
												</div>
											))}
										</div>
									}
								</div>
							<button onClick={e => this.modalDetails('closed')} className="btn blue-light">Close</button>
						</div>
					</div>
				}

				{ this.state.modal_last_sent === 'opened' && this.state.last_sent_target &&
					<div data-component="modal" className={`modal-cancel modal-last-sent opened`}>
						<div className="content">
							<div className="text">
								<h4>
									Last Sent Details
								</h4>

								<p className="last-sent-resume">
									{`${this.state.last_sent_target.sent_at
										? `Sent on ${this.formatScheduleDate(this.state.last_sent_target.sent_at)}`
										: "This project has not yet been submitted"}`}
								</p>

								<div className={`list-publishers-content new-list`}>
									{ lastSentRecipients.length === 0 &&
										<div className="item">
											<p className="text">This group has no contacts yet.</p>
										</div>
									}

									{ lastSentRecipients.map(group => (
										<div key={group.key} className={`item`}>
											<p className="text">{group.title}</p>

											<div className="collaborators-list">
												{group.people.map(person => (
													<p className="text" key={person.key}>
														{person.email ? `${person.name} (${person.email})` : person.name}
													</p>
												))}
											</div>
										</div>
									))}
								</div>
							</div>
							<button onClick={e => this.modalLastSent('closed')} className="btn blue-light">Close</button>
						</div>
					</div>
				}

				{ this.state.modal_delete === 'opened' &&
					<div data-component="modal" className={`modal-cancel opened`}>
						<div className="content">
							<p className="text">If you proceed you will lose all data saved in this list!<br /><b>Are you sure you want to delete this group?</b></p>
							<button onClick={e => this.modalDelete('closed')} className="btn grey">No</button>
							<button onClick={e => this.deleteList('closed', this.state.selectedSubmissionList)} to="/projects" className="btn blue-light">Yes</button>
						</div>
					</div>
				}
				
				{ this.state.modal_submitted === 'opened' &&
					<div data-component="modal" className={`modal-cancel modal_submitted opened`}>
						<div className="content">
							<p className="text">
								<b>All Done.</b>
								<br />
								<b>Sending Messages Successfully... <span className="loader-details"></span></b>
							</p>
						</div>
					</div>
				}
				
			</div>
		)
	};
}